/* Ronde 5 C1 (18 sep) — de lijstweergave bestaat niet meer.
   De twee knoppen zijn uit hn-facets.liquid; daarmee is toggleLayout() niet
   meer aan te roepen en kan niemand de weergave nog omzetten. Eén route bleef
   over: facets.js leest bij elke init localStorage["list-layout"] en zet
   listLayout op true als daar 'list' staat. Een bezoeker die vóór deze
   wijziging ooit op de lijstknop klikte, zou het raster dus nog steeds in
   lijstvorm krijgen — zonder knop om terug te schakelen.
   Daarom zetten we de sleutel hier op 'grid'. Dit bestand laadt met defer en
   facets.js komt pas na de eerste scroll binnen (deferScriptLoad in theme.js),
   dus dit staat er ruim op tijd. Weghalen van de sleutel zou ook kunnen, maar
   dan schrijft een oude, gecachte facets.js hem bij de volgende klik zo terug;
   een expliciete 'grid' is eenduidiger.
   Terugdraaien: deze regel weg én de knoppen terug in hn-facets.liquid. */
try { localStorage.setItem('list-layout', 'grid'); } catch (e) { /* privémodus */ }

/* ==========================================================================
   Hem-Nature — shared behaviour (page 04).
   One focus-trap implementation for every drawer/modal. Eurus's own
   xFocusElement helpers return early below 1025px (both trapFocus and
   removeTrapFocus), so every drawer needs width-independent focus handling.
   This file provides it once:

     - Alpine directive `x-hn-trap` on a panel: wraps Tab/Shift+Tab inside it
       at every width. Idempotent next to the vendor trap (>=1025px both run;
       same wrap decision).
     - window.HN helpers: focusables(root), focusFirst(root).
     - Auto-wiring for the vendor cart drawer (no vendor edit): an Alpine
       effect on $store.xMiniCart.open moves focus into #update-cart on open,
       traps it there, returns focus to the opener on close, and keeps
       aria-expanded/aria-controls on the #cart-icon trigger.

   No cart state lives here; cart data stays in xCartHelper/xMiniCart.
   ========================================================================== */

(function () {
  'use strict';

  var HN = {
    focusables: function (root) {
      if (!root) return [];
      var sel = 'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])';
      return Array.prototype.filter.call(root.querySelectorAll(sel), function (el) {
        return el.offsetParent !== null && !el.disabled;
      });
    },
    focusFirst: function (root) {
      var f = HN.focusables(root)[0];
      if (f) f.focus();
      return !!f;
    },
    wrap: function (panel, e) {
      if (e.key !== 'Tab') return;
      var f = HN.focusables(panel);
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      var active = document.activeElement;
      if (e.shiftKey) {
        if (active === first || !panel.contains(active)) { e.preventDefault(); last.focus(); }
      } else {
        if (active === last || !panel.contains(active)) { e.preventDefault(); first.focus(); }
      }
    },
    attach: function (panel) {
      if (!panel || panel._hnTrapWired) return;
      panel._hnTrapWired = true;
      panel.addEventListener('keydown', function (e) { HN.wrap(panel, e); });
    }
  };
  window.HN = HN;

  document.addEventListener('alpine:init', function () {
    /* x-hn-trap — put on the panel element of any hn drawer/modal. */
    Alpine.directive('hn-trap', function (el, _d, utils) {
      var handler = function (e) { HN.wrap(el, e); };
      el.addEventListener('keydown', handler);
      utils.cleanup(function () { el.removeEventListener('keydown', handler); });
    });
  });

  /* Search combobox enhancement (page 05) — keyboard + ARIA over the vendor
     predictive search. Machinery (debounce, fetch, cache) stays Eurus's
     xModalSearch; this only adds what a combobox needs:
       - aria-expanded / aria-controls on the input
       - ArrowDown/ArrowUp walk the rendered [role=option] items,
         aria-activedescendant follows, Enter opens the active option,
         Escape closes the panel and leaves focus in the input
       - the panel opens from 2 characters (design); Eurus opens at 1 */
  document.addEventListener('alpine:initialized', function () {
    var input = document.getElementById('header-search-in-modal');
    var panel = document.getElementById('header-search-result');
    if (!input || !panel || typeof Alpine === 'undefined') return;
    var host = input.closest('[x-data*=xModalSearch]') || document.querySelector('[x-data*=xModalSearch]');
    var data = host ? Alpine.$data(host) : null;
    if (!data) return;
    input.setAttribute('aria-controls', 'header-search-result');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    var active = -1;
    var options = function () {
      return Array.prototype.filter.call(panel.querySelectorAll('[role=option]'), function (o) { return o.offsetParent !== null; });
    };
    var setActive = function (idx) {
      var opts = options();
      opts.forEach(function (o) { o.setAttribute('aria-selected', 'false'); o.classList.remove('hn-option-active'); });
      active = idx;
      if (idx >= 0 && opts[idx]) {
        opts[idx].setAttribute('aria-selected', 'true');
        opts[idx].classList.add('hn-option-active');
        if (!opts[idx].id) opts[idx].id = 'hn-search-option-' + idx;
        input.setAttribute('aria-activedescendant', opts[idx].id);
        opts[idx].scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    };
    Alpine.effect(function () {
      var open = data.openResults && !data.loading;
      // design: suggestions from 2 characters
      if (data.openResults && data.query && data.query.length === 1) { open = false; queueMicrotask(function () { data.openResults = false; }); }
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) setActive(-1);
    });
    /* the vendor re-opens on keyup (keyUp() runs on every keyup incl. Escape);
       swallow the Escape keyup in capture phase so close sticks */
    var suppressEscUp = false;
    document.addEventListener('keyup', function (e) {
      if (e.target !== input) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter') { e.stopImmediatePropagation(); } /* navigation keys must not re-trigger the vendor search debounce */
      else if (e.key === 'Escape' && suppressEscUp) { suppressEscUp = false; e.stopImmediatePropagation(); }
    }, true);
    input.addEventListener('keydown', function (e) {
      var opts = options();
      if (e.key === 'ArrowDown' && opts.length) { e.preventDefault(); setActive(active + 1 >= opts.length ? 0 : active + 1); }
      else if (e.key === 'ArrowUp' && opts.length) { e.preventDefault(); setActive(active <= 0 ? opts.length - 1 : active - 1); }
      else if (e.key === 'Enter' && active >= 0 && opts[active]) {
        var link = opts[active].querySelector('a') || opts[active];
        if (link) { e.preventDefault(); link.click(); }
      } else if (e.key === 'Escape') {
        e.preventDefault(); /* native type=search Escape clears the value; design keeps the query */
        suppressEscUp = true;
        data.openResults = false; data.showSuggest = false;
        input.setAttribute('aria-expanded', 'false');
        setActive(-1);
      }
    });
  });

  /* Vendor cart drawer wiring — after Alpine booted, so the stores exist. */
  document.addEventListener('alpine:initialized', function () {
    if (typeof Alpine === 'undefined' || !Alpine.store('xMiniCart')) return;
    var opener = null;
    Alpine.effect(function () {
      var open = Alpine.store('xMiniCart').open;
      var icon = document.getElementById('cart-icon');
      if (icon) {
        if (!icon.getAttribute('aria-controls')) icon.setAttribute('aria-controls', 'CartDrawer');
        icon.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      if (open) {
        var active = document.activeElement;
        if (active && active !== document.body) opener = active;
        setTimeout(function () {
          var panel = document.getElementById('update-cart');
          if (!panel) return;
          HN.attach(panel);
          if (!panel.contains(document.activeElement)) HN.focusFirst(panel);
        }, 400);
      } else if (opener) {
        var o = opener;
        opener = null;
        setTimeout(function () {
          try { if (document.contains(o)) o.focus(); } catch (err) { /* gone */ }
        }, 150);
      }
    });
  });
})();


/* ==========================================================================
   Zoekpaneel — scheefstand van de ouder wegrekenen (20 okt 2026).

   WAT HET OPLOST
   Onder 1024px moet het zoekpaneel midden in het VENSTER staan, met links en
   rechts dezelfde marge. De CSS (§C1.6) doet dat met left: 50% plus een
   verschuiving van de halve paneelbreedte — maar die 50% rekent tegen de
   ouder van het paneel, en die staat niet overal even netjes in het midden.
   Gemeten op 20 okt: op 844 staat de ouder 6px naar rechts (de vendor zet
   daar zelf een inline transform van -6px die dat rechtzet), op 1023 staat
   hij 35px naar links en stak het paneel 17,5px voorbij de linkerrand.

   WAAROM DIT NIET IN CSS KAN
   Een absoluut geplaatst element rekent altijd tegen zijn containing block.
   De x daarvan is in CSS niet op te vragen; 100vw kent het venster wel, maar
   left telt nog steeds vanaf de ouder. position: fixed zou het oplossen, maar
   dan schuift het paneel niet meer mee met het zoekveld bij scrollen — ander
   gedrag dan vandaag. Zie het blok bij §C1.6 in hem-nature.css.

   WAT HET DOET
   Kijken waar het paneel feitelijk staat en het verschil met het midden in
   --hn-zoekpaneel-correctie zetten. Dus niet uitrekenen wat er allemaal aan
   het paneel trekt (de vendor-transform telt gewoon mee in de meting), maar
   het resultaat bijsturen. Eén meting, geen lus: na het zetten staat het er
   goed, en een volgende meting geeft dezelfde waarde.

   WANNEER
   Bij het inladen en bij elke verandering van de vensterbreedte — alleen dán
   verschuift de ouder. Niet bij scrollen (horizontaal verandert er niets) en
   niet bij het openen: het paneel staat al op zijn plek terwijl het nog
   onzichtbaar is, dus er valt niets te zien te springen.

   Vanaf 1024 wordt de eigenschap weggehaald: daar staat het paneel in de
   desktopweergave en raakt §C1.6 het niet aan.
   ========================================================================== */
(function () {
  'use strict';
  var EIGENSCHAP = '--hn-zoekpaneel-correctie';
  var GRENS = 1024;
  var gepland = false;

  function centreer() {
    gepland = false;
    var paneel = document.getElementById('header-search-result');
    if (!paneel) return;

    if (window.innerWidth >= GRENS) {
      paneel.style.removeProperty(EIGENSCHAP);
      return;
    }

    /* Eerst terug naar nul, anders meet je je eigen vorige correctie mee
       zodra het venster van breedte verandert. */
    paneel.style.setProperty(EIGENSCHAP, '0px');
    var vak = paneel.getBoundingClientRect();
    if (!vak.width) { paneel.style.removeProperty(EIGENSCHAP); return; }

    /* clientWidth en niet innerWidth: de schuifbalk van een desktopbrowser
       hoort niet mee te tellen bij het midden van wat je ziet. */
    var ruimte = document.documentElement.clientWidth;
    var gewenst = (ruimte - vak.width) / 2;
    var verschil = Math.round((gewenst - vak.left) * 10) / 10;
    paneel.style.setProperty(EIGENSCHAP, verschil + 'px');
  }

  function plan() {
    if (gepland) return;
    gepland = true;
    requestAnimationFrame(centreer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', plan);
  } else {
    plan();
  }
  window.addEventListener('resize', plan);
  window.addEventListener('orientationchange', plan);
  /* Nadat de letters geladen zijn kan de koptekst nog een paar pixels
     verspringen; die ronde nemen we mee. */
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(plan);
  }
})();


/* ==========================================================================
   Contactpagina — het succesvlak tonen, focussen en in beeld brengen.

   HET PROBLEEM DAT HIERONDER LIGT
   De server weet of er verstuurd is (form.posted_successfully?), maar die
   wetenschap komt alleen binnen als Shopify `?contact_posted=true` achter de
   return_to zet én die parameter de server bereikt. Twee dingen kunnen dat in
   de weg zitten:
    - een anker in de return_to. Dan belandt de parameter achter de # en gaat
      hij nooit naar de server. Dat was hier het geval tot 17 okt 2026 en
      daardoor heeft nog nooit iemand een bevestiging gezien. Opgelost in
      hn-contact.liquid: return_to is nu het pad zonder anker;
    - de captcha. Shopify beschermt dit formulier, en uit meldingen van andere
      winkeliers blijkt dat de parameter in dat pad soms niet terugkomt.

   DRIE LAGEN, in deze volgorde
    1. de server heeft het vlak al zichtbaar gerenderd. Dan hoeft hier alleen
       de focus en het scrollen te gebeuren;
    2. staat `contact_posted=true` in de querystring, dan is het gelukt en
       toont dit blok het vlak alsnog;
    3. en anders: heeft deze browser net zelf op "verstuur" geklikt, dan weet
       hij het ook. Dat wordt bij het versturen in sessionStorage gezet.

   EN WAT ER WAS INGEVULD
   Bij een foutmelding hoort alles te blijven staan. Shopify geeft `name`,
   `email` en `body` terug (die staan als value in de Liquid), maar de twee
   eigen velden — bestelnummer en onderwerp — zitten niet in het form-object en
   komen dus leeg terug. Daarom legt dit blok bij het versturen alle vijf de
   waarden even in sessionStorage en zet het ze terug zodra er een foutmelding
   op de pagina staat. Alleen velden die leeg zijn worden gevuld: wat de server
   wél teruggaf blijft staan. Na gebruik, en zodra het verstuurd is, wordt de
   opslag gewist — een bericht van een klant hoort niet in de browser te
   blijven liggen.

   WAAR LAAG 3 NIET MAG VUREN, want "je bericht is verstuurd" terwijl dat niet
   zo is, is erger dan geen melding:
    - staat er een foutmelding op de pagina, dan is er niets verstuurd;
    - is de pagina herladen in plaats van opnieuw geladen na een versturen,
      dan telt het niet (performance navigation type);
    - en na twee minuten vervalt het hoe dan ook.
   De vlag wordt bij de eerste beoordeling altijd gewist, geslaagd of niet.
   ========================================================================== */
(function () {
  'use strict';

  var SLEUTEL = 'hn-contact-verstuurd';
  var VELDSLEUTEL = 'hn-contact-velden';
  var GELDIG_MS = 120000;
  /* De twee eerste zijn tekstvelden, de laatste is de keuzelijst; die moet
     anders behandeld worden, want een keuzelijst is nooit "leeg". */
  var TEKSTVELDEN = ['hn-name', 'hn-order', 'hn-email', 'hn-body'];
  var KEUZEVELD = 'hn-subject';

  function vergeet() {
    try { sessionStorage.removeItem(SLEUTEL); } catch (e) { /* privémodus */ }
  }

  function vergeetVelden() {
    try { sessionStorage.removeItem(VELDSLEUTEL); } catch (e) { /* privémodus */ }
  }

  function onthoudVelden(form) {
    var uit = { t: Date.now() };
    TEKSTVELDEN.concat([KEUZEVELD]).forEach(function (id) {
      var el = form.querySelector('#' + id);
      if (el) uit[id] = el.value;
    });
    try { sessionStorage.setItem(VELDSLEUTEL, JSON.stringify(uit)); } catch (e) { /* privémodus */ }
  }

  function zetVeldenTerug() {
    var ruw = null;
    try { ruw = sessionStorage.getItem(VELDSLEUTEL); } catch (e) { return; }
    if (!ruw) return;
    vergeetVelden();
    var opslag = null;
    try { opslag = JSON.parse(ruw); } catch (e) { return; }
    if (!opslag || Date.now() - Number(opslag.t) > GELDIG_MS) return;

    TEKSTVELDEN.forEach(function (id) {
      var el = document.getElementById(id);
      /* Alleen vullen wat leeg is: gaf de server de waarde al terug, dan is
         die de waarheid. */
      if (el && !el.value && opslag[id]) el.value = opslag[id];
    });

    var keuze = document.getElementById(KEUZEVELD);
    if (keuze && opslag[KEUZEVELD] && !keuze.querySelector('option[selected]')) {
      for (var i = 0; i < keuze.options.length; i += 1) {
        if (keuze.options[i].value === opslag[KEUZEVELD]) { keuze.value = opslag[KEUZEVELD]; break; }
      }
    }
  }

  function naarVoren(vlak) {
    try { vlak.focus({ preventScroll: true }); } catch (e) { vlak.focus(); }
    vlak.scrollIntoView({ block: 'start' });
  }

  function toon(vlak, bron) {
    var velden = document.querySelector('[data-hn-contact-velden]');
    if (velden) velden.hidden = true;
    vlak.hidden = false;
    vlak.setAttribute('data-hn-bron', bron);
    naarVoren(vlak);
  }

  function herladen() {
    try {
      var n = performance.getEntriesByType('navigation')[0];
      return !!n && n.type === 'reload';
    } catch (e) { return false; }
  }

  function start() {
    var vlak = document.querySelector('[data-hn-contact-ok]');
    if (!vlak) return;

    /* 1. de server heeft het al gerenderd */
    if (!vlak.hidden) { vergeet(); vergeetVelden(); naarVoren(vlak); return; }

    /* Staat er een foutmelding, dan is er niets verstuurd: de vlag mag weg en
       wat er was ingevuld gaat terug in het formulier. */
    if (document.querySelector('.hn-contact__fout, .hn-contact__banner--err')) {
      vergeet();
      zetVeldenTerug();
      return;
    }

    /* 2. de parameter in de URL. Alleen de letterlijke waarde true telt, zodat
       een contact_posted=false (of wat Shopify er ook van maakt bij een fout)
       nooit als geslaagd wordt gelezen. */
    var gelukt = false;
    try {
      gelukt = new URLSearchParams(window.location.search).get('contact_posted') === 'true';
    } catch (e) { gelukt = window.location.search.indexOf('contact_posted=true') >= 0; }
    if (gelukt) { vergeet(); vergeetVelden(); toon(vlak, 'url'); return; }

    /* 3. de eigen vlag van deze browser */
    var vlag = null;
    try { vlag = sessionStorage.getItem(SLEUTEL); } catch (e) { vlag = null; }
    if (!vlag) return;
    vergeet();
    if (herladen()) return;
    if (Date.now() - Number(vlag) > GELDIG_MS) return;
    vergeetVelden();
    toon(vlak, 'vlag');
  }

  /* De vlag zetten op het moment dat het formulier echt de deur uit gaat.
     In de capture-fase, zodat het ook gebeurt als iets anders het event
     onderweg nog afvangt. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.id !== 'hn-form') return;
    /* Gaat het formulier via het Apps Script, dan laadt de pagina niet opnieuw
       en regelt dat blok zijn eigen succesvlak. De vlag zou dan blijven liggen
       en bij een volgend bezoek binnen twee minuten een valse melding geven. */
    if (!appsScriptUrl()) {
      try { sessionStorage.setItem(SLEUTEL, String(Date.now())); } catch (err) { /* privémodus */ }
    }
    onthoudVelden(f);
  }, true);

  /* ======================================================================
     Versturen naar het Apps Script: bijlagen en een bevestigingsmail.

     Alleen als de sectie-instelling "Apps Script URL" gevuld is. Dan staat die
     URL op het veldenomhulsel, en gaat het formulier met fetch die kant op in
     plaats van naar Shopify. Is de instelling leeg of doet JavaScript het niet,
     dan post het formulier gewoon naar Shopify — zonder bijlagen, maar het
     komt aan, en het succesvlak werkt dan langs de bestaande weg.

     De POST gaat als JSON in een text/plain-body, zonder Content-Type-header.
     Dat is met opzet: dan is het voor de browser een "simple request" en vraagt
     hij geen CORS-preflight, en daar kan een Apps Script-webapp niet op
     antwoorden.
     ====================================================================== */

  var MAX_WACHT_MS = 120000;
  /* Alleen een terugval voor als het attribuut ontbreekt. De echte grens komt
     uit de sectie-instelling "Maximale totale grootte (MB)" en hoort gelijk te
     staan aan MAIL_VEILIG_MB in het Apps Script. */
  var MAX_MB_TERUGVAL = 18;
  var bezig = false;
  var gekozen = [];

  var FOUTTEKST = {
    'velden-leeg': 'Vul je naam, je e-mailadres en je bericht in.',
    'email-ongeldig': 'Dat e-mailadres klopt niet helemaal. Kun je het nog even nakijken?',
    'te-snel': 'Dat ging wel erg snel. Probeer het nog een keer.',
    'te-veel-bestanden': 'Je kunt niet zoveel bestanden tegelijk meesturen.',
    'te-groot': 'De bestanden zijn samen te groot om mee te sturen.',
    'type-niet-toegestaan': 'Alleen foto\'s en video\'s kunnen mee.',
    'bestand-onleesbaar': 'Een van de bestanden kwam beschadigd aan. Probeer het nog eens.',
    'te-vaak': 'Je hebt net al een paar berichten gestuurd. Probeer het over tien minuten nog eens.',
    /* {mail} wordt het adres uit de pagina; staat die plaatshouder in de tekst,
       dan plakt meldFout er niets meer achter. */
    'te-druk': 'Het is even erg druk. Probeer het over een paar minuten opnieuw of mail ons op {mail}.',
    'mail-mislukt': 'Het versturen lukte niet.',
    'honeypot': 'Je bericht kon niet verstuurd worden.',
    'geen-body': 'Je bericht kon niet verstuurd worden.'
  };

  function omhulsel() {
    return document.querySelector('[data-hn-contact-velden]');
  }

  function appsScriptUrl() {
    var el = omhulsel();
    return el ? el.getAttribute('data-hn-contact-url') : null;
  }

  function getalUit(el, naam, standaard) {
    var n = Number(el ? el.getAttribute(naam) : NaN);
    return (!n || isNaN(n)) ? standaard : n;
  }

  function mbTekst(bytes) {
    if (bytes < 1048576) return Math.max(1, Math.round(bytes / 1024)) + ' kB';
    return (Math.round(bytes / 104857.6) / 10) + ' MB';
  }

  function mailAdres() {
    var a = document.querySelector('.hn-contact__v a[href^="mailto:"]');
    return a ? a.textContent.trim() : 'klantenservice@hemnature.com';
  }

  /** De grens voor de bestanden samen, in MB. Eén bron: de sectie-instelling. */
  function maxMb() {
    return getalUit(omhulsel(), 'data-hn-max-mb', MAX_MB_TERUGVAL);
  }

  function meldFout(tekst) {
    var balk = document.querySelector('[data-hn-contact-melding]');
    if (!balk) return;
    balk.textContent = tekst.indexOf('{mail}') >= 0
      ? tekst.replace('{mail}', mailAdres())
      : tekst + ' Je kunt ons ook mailen op ' + mailAdres() + '.';
    balk.hidden = false;
    balk.scrollIntoView({ block: 'nearest' });
  }

  function wisMelding() {
    var balk = document.querySelector('[data-hn-contact-melding]');
    if (balk) { balk.hidden = true; balk.textContent = ''; }
  }

  function uploadFout(tekst) {
    var p = document.querySelector('[data-hn-upload-fout]');
    var invoer = document.querySelector('[data-hn-upload-invoer]');
    if (!p) return;
    if (!tekst) {
      p.hidden = true;
      p.textContent = '';
      if (invoer) {
        invoer.removeAttribute('aria-invalid');
        invoer.setAttribute('aria-describedby', 'hn-files-uitleg');
      }
      return;
    }
    p.textContent = tekst;
    p.hidden = false;
    if (invoer) {
      invoer.setAttribute('aria-invalid', 'true');
      invoer.setAttribute('aria-describedby', 'hn-files-uitleg hn-files-fout');
    }
  }

  function totaalBytes() {
    var n = 0;
    for (var i = 0; i < gekozen.length; i += 1) n += gekozen[i].size;
    return n;
  }

  function tekenLijst(blok) {
    var lijst = blok.querySelector('[data-hn-upload-lijst]');
    var teller = blok.querySelector('[data-hn-upload-teller]');
    var maxBestanden = getalUit(omhulsel(), 'data-hn-max-bestanden', 5);
    var grens = maxMb();

    lijst.textContent = '';
    gekozen.forEach(function (bestand, index) {
      var li = document.createElement('li');
      li.className = 'hn-contact__bestand';

      var naam = document.createElement('span');
      naam.className = 'hn-contact__bestand-naam';
      naam.textContent = bestand.name;

      var maat = document.createElement('span');
      maat.className = 'hn-contact__bestand-maat';
      maat.textContent = mbTekst(bestand.size);

      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'hn-contact__bestand-weg';
      knop.setAttribute('aria-label', 'Verwijder ' + bestand.name);
      knop.textContent = '×';
      knop.addEventListener('click', function () {
        gekozen.splice(index, 1);
        uploadFout('');
        tekenLijst(blok);
      });

      li.appendChild(naam);
      li.appendChild(maat);
      li.appendChild(knop);
      lijst.appendChild(li);
    });

    if (gekozen.length === 0) {
      teller.textContent = 'Maximaal ' + maxBestanden + ' bestanden, samen ' + grens + ' MB. Foto\'s en video\'s.';
    } else {
      teller.textContent = gekozen.length + (gekozen.length === 1 ? ' bestand' : ' bestanden')
        + ' · ' + mbTekst(totaalBytes()) + ' van ' + grens + ' MB';
    }
  }

  /* Kiezen, verkleinen, en dan pas meten of het past.
     De grens van achttien MB gaat over wat er werkelijk de deur uit gaat, dus
     over de verkleinde foto — anders zou een bezoeker afgewezen worden op een
     maat die we zelf nog gaan verkleinen. Het aantal bestanden wordt wél
     vooraf getoetst: dan hoeven er geen zeven foto's door de molen om er
     daarna vijf van te houden. */
  function voegBestandenToe(nieuwe, blok) {
    var maxBestanden = getalUit(omhulsel(), 'data-hn-max-bestanden', 5);
    var melding = '';
    var teDoen = [];

    for (var i = 0; i < nieuwe.length; i += 1) {
      var bestand = nieuwe[i];
      var type = bestand.type || '';
      if (type.indexOf('image/') !== 0 && type.indexOf('video/') !== 0) {
        melding = '"' + bestand.name + '" kan niet mee: alleen foto\'s en video\'s.';
        continue;
      }
      if (gekozen.length + teDoen.length >= maxBestanden) {
        melding = 'Je kunt maximaal ' + maxBestanden + ' bestanden meesturen.';
        break;
      }
      teDoen.push(bestand);
    }

    if (teDoen.length === 0) {
      uploadFout(melding);
      tekenLijst(blok);
      return;
    }

    var aantalFotos = teDoen.filter(teVerkleinen).length;
    if (aantalFotos > 0) meldBezig(blok, aantalFotos);
    verkleinenBezig += 1;
    zetKnop();

    Promise.all(teDoen.map(verklein)).then(function (klaar) {
      var maxBytes = maxMb() * 1048576;
      for (var j = 0; j < klaar.length; j += 1) {
        if (totaalBytes() + klaar[j].size > maxBytes) {
          melding = 'Samen passen de bestanden niet: dat wordt '
            + mbTekst(totaalBytes() + klaar[j].size) + ' van maximaal ' + maxMb() + ' MB.';
          continue;
        }
        gekozen.push(klaar[j]);
      }
      verkleinenBezig -= 1;
      zetKnop();
      uploadFout(melding);
      tekenLijst(blok);
    });
  }

  /* Verkleinen kost op een telefoon een halve seconde per foto. Dat is kort,
     maar niet zo kort dat je het niet merkt als er niets gebeurt. */
  function meldBezig(blok, aantal) {
    var teller = blok.querySelector('[data-hn-upload-teller]');
    if (teller) {
      teller.textContent = aantal === 1
        ? 'De foto wordt verkleind…'
        : 'De ' + aantal + ' foto\'s worden verkleind…';
    }
  }

  /* De knop staat uit zolang er nog een foto in de molen zit: versturen zou
     dan een pakket zonder die bijlage opleveren. */
  function zetKnop() {
    var knop = document.querySelector('[data-hn-knop]');
    if (!knop || bezig) return;
    knop.disabled = verkleinenBezig > 0;
  }

  /* ====================================================================
     FOTO'S VERKLEINEN VOOR HET VERSTUREN (27 okt 2026)

     Gemeten op het testthema, twee telefoonfoto's van vijf MB: 82 seconden
     van knop tot bevestiging. Daarvan ging 46 seconden aan de upload en 36
     aan het script. Het inlezen en coderen in de browser kostte 60
     milliseconden — daar zat het dus niet.

     Tien MB aan foto's wordt als base64 dertien MB over de lijn, en een
     gewone upstream haalt daar driekwart minuut over. Een foto van 4000 pixels
     breed is in een mailtje over een beschadigd pakketje ook geen cent meer
     waard dan een van 2000. Dus verkleinen vóór het versturen, op het moment
     dat iemand het bestand kiest — dan rekent de teller er meteen mee en zie
     je als bezoeker wat je echt meestuurt.

     WAT ER NIET VERKLEIND WORDT
     Video's niet: daar is in de browser geen omzetting voor die dit waard is.
     GIF's niet, want die kunnen bewegen en dat zou één stilstaand plaatje
     worden. En wat de browser niet kan uitpakken (HEIC van een iPhone bij een
     oudere browser, AVIF) gaat ongemoeid mee: dan valt het terug op het
     origineel in plaats van op een foutmelding.

     DE ORIËNTATIE UIT DE EXIF MOET MEE
     Een telefoon slaat een staande foto vaak liggend op, met een vlaggetje
     erbij dat zegt hoe hij gedraaid hoort te worden. Tekent de browser zo'n
     foto zonder dat vlaggetje op een canvas, dan komt hij gekanteld aan — en
     dan heb je de foto van de klant stukgemaakt in plaats van verkleind. Een
     <img> leest die oriëntatie zelf (image-orientation staat standaard op
     from-image) en geeft in naturalWidth/naturalHeight de al gedraaide maten;
     drawImage volgt dat. Nagemeten in deze browser met een eigen proefbestand:
     een liggende 4000x3000 met vlaggetje 6 komt eruit als 1500x2000, dus
     staand. Zie tools/maak-proefbestanden.mjs.

     ALLEEN ALS HET KLEINER WORDT
     Een foto die al klein is, of die zich slecht laat comprimeren, komt uit de
     molen soms groter terug. Dan houden we het origineel. Dat is ook de reden
     dat het resultaat pas aan het eind vergeleken wordt en niet vooraf
     geschat.
     ==================================================================== */

  var VERKLEIN_ZIJDE = 2000;
  var VERKLEIN_KWALITEIT = 0.85;
  var VERKLEINBAAR = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  /* Zolang dit boven nul staat is er nog een foto onderweg en mag er niet
     verstuurd worden: het pakket zou dan zonder die bijlage de deur uit gaan. */
  var verkleinenBezig = 0;

  function teVerkleinen(bestand) {
    return VERKLEINBAAR.indexOf(String(bestand.type || '').toLowerCase()) >= 0;
  }

  function laadBeeld(bestand) {
    return new Promise(function (klaar, mislukt) {
      var url = URL.createObjectURL(bestand);
      var img = new Image();
      img.onload = function () { URL.revokeObjectURL(url); klaar(img); };
      img.onerror = function () { URL.revokeObjectURL(url); mislukt(new Error('niet te lezen')); };
      img.src = url;
    });
  }

  /* Zit er ook maar één doorzichtige pixel in, dan moet het PNG blijven: als
     JPEG wordt doorzicht zwart. Lukt het uitlezen niet (een canvas dat de
     browser niet wil vrijgeven), dan is PNG de veilige kant. */
  function heeftDoorzicht(ctx, breed, hoog) {
    try {
      var data = ctx.getImageData(0, 0, breed, hoog).data;
      for (var i = 3; i < data.length; i += 4) {
        if (data[i] < 255) return true;
      }
      return false;
    } catch (e) {
      return true;
    }
  }

  function nieuweNaam(naam, type) {
    var basis = String(naam || 'foto').replace(/\.[^.\s]+$/, '');
    return basis + (type === 'image/png' ? '.png' : '.jpg');
  }

  function verklein(bestand) {
    if (!teVerkleinen(bestand)) return Promise.resolve(bestand);
    var proef = document.createElement('canvas');
    if (!proef.toBlob || !window.File || !window.URL || !URL.createObjectURL) {
      return Promise.resolve(bestand);
    }

    return laadBeeld(bestand).then(function (beeld) {
      var breed = beeld.naturalWidth;
      var hoog = beeld.naturalHeight;
      if (!breed || !hoog) return bestand;

      var schaal = Math.min(1, VERKLEIN_ZIJDE / Math.max(breed, hoog));
      var nieuwBreed = Math.max(1, Math.round(breed * schaal));
      var nieuwHoog = Math.max(1, Math.round(hoog * schaal));

      var canvas = document.createElement('canvas');
      canvas.width = nieuwBreed;
      canvas.height = nieuwHoog;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(beeld, 0, 0, nieuwBreed, nieuwHoog);

      var pngHouden = String(bestand.type).toLowerCase() === 'image/png'
        && heeftDoorzicht(ctx, nieuwBreed, nieuwHoog);
      var type = pngHouden ? 'image/png' : 'image/jpeg';

      return new Promise(function (klaar) {
        canvas.toBlob(function (blob) {
          if (!blob || blob.size >= bestand.size) { klaar(bestand); return; }
          try {
            klaar(new File([blob], nieuweNaam(bestand.name, type), { type: type }));
          } catch (e) {
            /* Oudere browser zonder de File-constructor: dan het origineel,
               want een Blob zonder naam zou de bestandsnaam kwijtmaken. */
            klaar(bestand);
          }
        }, type, pngHouden ? undefined : VERKLEIN_KWALITEIT);
      });
    }).catch(function () {
      /* Niet uit te pakken, geen geheugen, wat dan ook: het origineel gaat
         mee. Een bericht dat aankomt is meer waard dan een kleine bijlage. */
      return bestand;
    });
  }

  /* De meting hangt hieraan (tools/meet-tijden.mjs --droog): die stopt er een
     bestand in met een bekende EXIF-oriëntatie en kijkt wat eruit komt. Zonder
     deze haak zou dat niet te toetsen zijn zonder de code te veranderen. */
  window.hnVerkleinFoto = verklein;

  function leesAlsBase64(bestand) {
    return new Promise(function (klaar, mislukt) {
      var lezer = new FileReader();
      lezer.onload = function () {
        var waarde = String(lezer.result || '');
        var komma = waarde.indexOf(',');
        klaar({
          name: bestand.name,
          mimeType: bestand.type || 'application/octet-stream',
          data: komma >= 0 ? waarde.slice(komma + 1) : ''
        });
      };
      lezer.onerror = function () { mislukt(new Error('lezen mislukt')); };
      lezer.readAsDataURL(bestand);
    });
  }

  function waardeVan(id) {
    var el = document.getElementById(id);
    return el ? el.value : '';
  }

  /* ====================================================================
     VERSTUREN, EN WAAROM ER GEEN PERCENTAGE STAAT (27 okt 2026)

     Gemeten duurt de upload bij een video van tien MB 47 seconden, en in die
     47 seconden stond er alleen "Bezig met versturen…". Dat is lang genoeg om
     te denken dat het formulier niets doet, en om het nog een keer te
     proberen. Daar hoort iets zichtbaars bij.

     EERST MET XMLHttpRequest GEPROBEERD, EN DAT BREEKT HET FORMULIER.
     Alleen XHR heeft upload.onprogress, en daarmee een echt percentage. Maar:
     zodra er één luisteraar op xhr.upload staat, is het verzoek volgens de
     standaard geen "simple request" meer en stuurt de browser er een
     CORS-preflight voor uit. En die kan een Apps Script-webapp niet
     beantwoorden. Nagemeten op de webapp zelf:

       OPTIONS  ->  200, Allow: HEAD, GET, POST, geen Access-Control-Allow-Origin
       POST     ->  302, Access-Control-Allow-Origin: *

     De POST mag dus wél, de preflight niet. Met de luisteraars erop kreeg elke
     bezoeker "Er ging iets mis bij het versturen." Het is op live gegaan en
     daar binnen het uur op betrapt; in de meetbrowser kwam diezelfde preflight
     er met een 204 doorheen, dus de meting zag het niet. Een groene meting is
     geen werkende pagina.

     DUS: fetch, en een balk die beweegt zonder te tellen. Een percentage is
     hier niet eerlijk te maken — niet met een schatting op basis van tijd, en
     niet met een balk die op 90 blijft hangen. Wat de bezoeker nodig heeft is
     weten dat er iets gebeurt en dat hij niet nog een keer moet klikken; dat
     doet een lopende balk net zo goed.
     ==================================================================== */

  function verstuurViaAppsScript(form, url, knop, oudeKnoptekst) {
    var vlak = document.querySelector('[data-hn-contact-ok]');

    Promise.all(gekozen.map(leesAlsBase64)).then(function (bestanden) {
      var pakket = {
        name: waardeVan('hn-name'),
        email: waardeVan('hn-email'),
        bestelnummer: waardeVan('hn-order'),
        onderwerp: waardeVan('hn-subject'),
        body: waardeVan('hn-body'),
        website: waardeVan('hn-website'),
        startedAt: Number((form.querySelector('[data-hn-startedat]') || {}).value || 0),
        files: bestanden
      };
      toonBezig(knop);
      return verzend(url, JSON.stringify(pakket));
    }).then(function (uitslag) {
      if (uitslag && uitslag.ok) {
        vergeet();
        vergeetVelden();
        wisMelding();
        wisVoortgang();
        if (vlak) toon(vlak, 'appsscript');
        return;
      }
      var code = (uitslag && uitslag.error) || 'onbekend';
      herstelKnop(knop, oudeKnoptekst);
      meldFout(FOUTTEKST[code] || 'Er ging iets mis bij het versturen.');
    }).catch(function (fout) {
      herstelKnop(knop, oudeKnoptekst);
      meldFout(fout && fout.hnTeLang
        ? 'Het versturen duurde te lang.'
        : 'Er ging iets mis bij het versturen.');
    });
  }

  /* Eén POST, zonder een enkele eigen header: dan stuurt de browser
     text/plain en blijft het een simple request. Geen preflight dus — zie het
     blok hierboven, daar hangt het hele formulier aan. */
  function verzend(url, body) {
    var afbreker = null;
    var tijdklok = null;
    var opties = { method: 'POST', body: body };
    if (window.AbortController) {
      afbreker = new AbortController();
      opties.signal = afbreker.signal;
      tijdklok = setTimeout(function () { afbreker.abort(); }, MAX_WACHT_MS);
    }
    return fetch(url, opties).then(function (reactie) {
      if (tijdklok) clearTimeout(tijdklok);
      return reactie.json();
    }, function (fout) {
      if (tijdklok) clearTimeout(tijdklok);
      if (fout && fout.name === 'AbortError') fout.hnTeLang = true;
      throw fout;
    });
  }

  function voortgangDelen() {
    return {
      balk: document.querySelector('[data-hn-voortgang]'),
      vulling: document.querySelector('[data-hn-voortgang-balk]'),
      tekst: document.querySelector('[data-hn-voortgang-tekst]')
    };
  }

  /* De balk gaat lopen en de regel eronder zegt één keer wat er gebeurt. Eén
     keer, want dit is een aria-live-gebied: een regel die zichzelf blijft
     bijwerken wordt voorgelezen en voorgelezen. De zin noemt foto's en video's
     met opzet — dan weet iemand met een video van tien MB dat het even duurt
     en is wachten geen raden. */
  function toonBezig(knop) {
    var d = voortgangDelen();
    if (d.balk) {
      d.balk.hidden = false;
      d.balk.classList.add('hn-contact__voortgang--loopt');
    }
    if (knop) knop.textContent = 'Bezig met versturen…';
    if (d.tekst) {
      d.tekst.hidden = false;
      d.tekst.textContent = 'Bezig met versturen… bij foto\'s en video\'s kan dit even duren.';
    }
  }

  function wisVoortgang() {
    var d = voortgangDelen();
    if (d.balk) {
      d.balk.hidden = true;
      d.balk.classList.remove('hn-contact__voortgang--loopt');
    }
    if (d.tekst) { d.tekst.hidden = true; d.tekst.textContent = ''; }
  }

  function herstelKnop(knop, tekst) {
    bezig = false;
    knop.disabled = false;
    knop.textContent = tekst;
    wisVoortgang();
  }

  function startVerzender() {
    var url = appsScriptUrl();
    if (!url) return;
    var form = document.getElementById('hn-form');
    var blok = document.querySelector('[data-hn-upload]');
    if (!form) return;

    /* Het tijdstip waarop de pagina geladen is; het script weigert alles wat
       binnen drie seconden daarna binnenkomt. */
    var start = form.querySelector('[data-hn-startedat]');
    if (start) start.value = String(Date.now());

    /* De verstuurknop staat verborgen en uitgeschakeld in de pagina: langs deze
       weg gaat er zonder JavaScript niets weg. Nu JavaScript draait, mag hij
       zichtbaar worden. */
    var startknop = form.querySelector('[data-hn-knop]');
    if (startknop) {
      startknop.hidden = false;
      startknop.disabled = false;
    }

    if (blok) {
      blok.hidden = false;
      var invoer = blok.querySelector('[data-hn-upload-invoer]');
      if (invoer) {
        invoer.addEventListener('change', function () {
          voegBestandenToe(Array.prototype.slice.call(invoer.files || []), blok);
          /* Leegmaken, anders kan dezelfde foto niet nog eens gekozen worden
             en stapelt de lijst dubbel bij een tweede keuze. */
          invoer.value = '';
        });
      }
      tekenLijst(blok);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (bezig) return;
      /* Nog een foto in de molen: dan zou het pakket zonder die bijlage weggaan.
         De knop staat op dat moment al uit; dit is het vangnet voor een
         enter-toets in een veld. */
      if (verkleinenBezig > 0) {
        meldFout('De foto\'s worden nog verkleind. Nog een momentje.');
        return;
      }
      if (form.checkValidity && !form.checkValidity()) {
        if (form.reportValidity) form.reportValidity();
        return;
      }
      wisMelding();
      var knop = form.querySelector('.hn-contact__btn');
      var oud = knop.textContent;
      bezig = true;
      knop.disabled = true;
      knop.textContent = 'Bezig met versturen…';
      verstuurViaAppsScript(form, url, knop, oud);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); startVerzender(); });
  } else {
    start();
    startVerzender();
  }
})();


/* ==========================================================================
   Page 06 (klantenservice) — deep-linkable accordions.
   Generic: when the URL hash points at an element that contains a closed
   button[aria-expanded], the button is clicked (Alpine toggles the panel)
   and the item scrolls into view. Works for hn-service-topics anchors
   (#v-<vraag>) and for any future accordion whose items carry ids.
   ========================================================================== */
(function () {
  'use strict';
  function hnOpenFromHash() {
    var h = window.location.hash;
    if (!h || h.length < 2) return;
    var el = document.getElementById(decodeURIComponent(h.slice(1)));
    if (!el) return;
    /* 4 sep: pak de EERSTE accordeonknop, niet de eerste dichte. Bij het eerste
       onderwerp staat vraag 1 al open (hn-service-topics zet current: 1 voor
       topic_index 1); "de eerste dichte" was daar dus vraag 2, die openklapte
       en vraag 1 dichttrok. Staat de eerste knop al open, dan is er niets te
       doen — de bezoeker landt op een open vraag, wat de bedoeling was. */
    var btn = el.querySelector('button[aria-expanded]');
    if (btn && btn.getAttribute('aria-expanded') === 'false') btn.click();
    /* RONDE 4 (12 sep): dit stond op block: 'center'. Daarmee landt het
       aangeklikte onderwerp halverwege het scherm en staat de kop 312px lager
       dan waar de bezoeker hem verwacht. Nu bovenaan, met scroll-margin-top in
       de CSS voor de vastgeplakte header (zelfde 85px als de PDP-kolommen). */
    setTimeout(function () { el.scrollIntoView({ block: 'start' }); }, 150);
  }
  document.addEventListener('alpine:initialized', function () { setTimeout(hnOpenFromHash, 50); });
  window.addEventListener('hashchange', hnOpenFromHash);
})();


/* ==========================================================================
   Pagina 06 (klantenservice) — het snelmenu volgt de sectie die in beeld is.

   WAAROM NU WEL
   De markering stond vast op het eerste onderwerp: de pagina rendert hem en
   daarna gebeurde er niets meer (besluit 12 sep). Sinds het zijmenu meeschuift
   kijk je er de hele pagina tegenaan, en dan klopt een menu dat "Bestellen"
   gemarkeerd houdt terwijl je "Account en gegevens" leest niet meer.

   HOE
   Een IntersectionObserver, geen scroll-listener: de browser meldt zelf
   wanneer een onderwerp een smalle band bovenin het venster kruist — van 88px
   (net onder de vastgeplakte kop en onder de 85px waarop het zijmenu staat)
   tot 35% van de vensterhoogte. Kruisen er meerdere, dan wint de bovenste.
   Kruist er geen enkele — bovenaan bij de kop en de kaarten, onderaan bij de
   contactbanner — dan blijft staan wat er stond; springen naar niets is
   verwarrender dan even niets doen.

   ONDERAAN DE PAGINA
   Daar kan het laatste onderwerp de band niet meer bereiken: de pagina is op
   voordat zijn kop zo hoog komt. Gemeten op 390px staat het laatste onderwerp
   dan op 275..360 terwijl het vorige nog van −171 tot 257 loopt — allebei in
   de band, en dan wint het bovenste, dus bleef "Producten en gebruik" staan
   terwijl je "Account en gegevens" voor je neus had. Een onzichtbaar meetpunt
   van 1px helemaal onderaan (met margin-top −1px, dus de pagina wordt er geen
   pixel langer van) meldt wanneer de onderkant in beeld is. Zolang dat zo is
   wint het ONDERSTE onderwerp dat in beeld staat.

   NA EEN KLIK
   Dan luistert hij een seconde niet. Tijdens het springen naar het anker
   schuiven er onderwerpen door de band die de bezoeker niet gekozen heeft; die
   zouden de markering laten knipperen en hem op het verkeerde item achterlaten
   als het anker onderaan de pagina ligt. Het aangeklikte item blijft dus staan
   tot er echt verder gescrold wordt.

   MOBIEL
   Daar is .hn-st__nav een rij chips die horizontaal scrollt. De actieve chip
   staat dan maar zo buiten beeld, dus die wordt in de rij naar binnen
   geschoven — alleen horizontaal binnen de rij zelf, nooit de pagina.
   ========================================================================== */
(function () {
  'use strict';

  function nu() {
    return (window.performance && window.performance.now) ? window.performance.now() : Date.now();
  }

  function start() {
    var nav = document.querySelector('.hn-st__nav');
    if (!nav || !('IntersectionObserver' in window)) return;

    /* Elk menu-item wijst met zijn href naar de sectie eronder (#ks-<naam>).
       Items zonder sectie slaan we over: dan is er niets te volgen. */
    var links = nav.querySelectorAll('.hn-st__nav-link');
    var paren = [];
    for (var i = 0; i < links.length; i += 1) {
      var href = links[i].getAttribute('href') || '';
      var sectie = href.charAt(0) === '#' ? document.getElementById(decodeURIComponent(href.slice(1))) : null;
      if (sectie) paren.push({ link: links[i], sectie: sectie });
    }
    if (paren.length < 2) return;

    var kruist = [];
    var huidig = -1;
    var stilTot = 0;
    var aanDeBodem = false;
    var rustig = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function chipInBeeld(link) {
      /* Valt er niets te schuiven, dan staat het menu als kolom (desktop). */
      if (nav.scrollWidth <= nav.clientWidth + 1) return;
      /* Met getBoundingClientRect en niet met offsetLeft: offsetLeft rekent
         vanaf het dichtstbijzijnde gepositioneerde element, en dat is de rij
         zelf niet. Bij de laatste chip liep de rekensom daardoor mis en bleef
         hij buiten beeld staan. */
      var nd = nav.getBoundingClientRect();
      var cd = link.getBoundingClientRect();
      var doel = null;
      if (cd.left < nd.left + 12) doel = nav.scrollLeft - (nd.left + 12 - cd.left);
      else if (cd.right > nd.right - 12) doel = nav.scrollLeft + (cd.right - (nd.right - 12));
      if (doel === null) return;
      doel = Math.max(0, Math.min(doel, nav.scrollWidth - nav.clientWidth));
      if (nav.scrollTo) nav.scrollTo({ left: doel, behavior: rustig ? 'auto' : 'smooth' });
      else nav.scrollLeft = doel;
    }

    function markeer(n) {
      if (n < 0 || n === huidig) return;
      huidig = n;
      for (var k = 0; k < paren.length; k += 1) {
        if (k === n) paren[k].link.setAttribute('aria-current', 'true');
        else paren[k].link.removeAttribute('aria-current');
      }
      chipInBeeld(paren[n].link);
    }

    function kies() {
      if (nu() < stilTot) return;
      /* Onderaan de pagina: het onderste onderwerp dat nog in beeld staat. */
      if (aanDeBodem) {
        for (var z = paren.length - 1; z >= 0; z -= 1) {
          var doos = paren[z].sectie.getBoundingClientRect();
          if (doos.top < window.innerHeight && doos.bottom > 88) { markeer(z); return; }
        }
      }
      /* Normaal: het bovenste onderwerp dat de band kruist. */
      for (var k = 0; k < paren.length; k += 1) {
        if (kruist[k]) { markeer(k); return; }
      }
    }

    var io = new IntersectionObserver(function (entries) {
      for (var e = 0; e < entries.length; e += 1) {
        for (var n = 0; n < paren.length; n += 1) {
          if (paren[n].sectie === entries[e].target) { kruist[n] = entries[e].isIntersecting; break; }
        }
      }
      kies();
    }, { rootMargin: '-88px 0px -65% 0px', threshold: 0 });

    for (var p = 0; p < paren.length; p += 1) {
      kruist[p] = false;
      io.observe(paren[p].sectie);
    }

    /* Het meetpunt op de bodem. Geen hoogte erbij: 1px hoog met 1px negatieve
       bovenmarge, dus de pagina blijft even lang als hij was. */
    var bodem = document.createElement('div');
    bodem.setAttribute('aria-hidden', 'true');
    bodem.style.cssText = 'height:1px;margin-top:-1px;pointer-events:none;';
    document.body.appendChild(bodem);
    new IntersectionObserver(function (entries) {
      aanDeBodem = entries[entries.length - 1].isIntersecting;
      kies();
    }, { threshold: 0 }).observe(bodem);

    nav.addEventListener('click', function (e) {
      var el = e.target;
      var link = (el && el.closest) ? el.closest('.hn-st__nav-link') : null;
      if (!link) return;
      for (var n = 0; n < paren.length; n += 1) {
        if (paren[n].link === link) { stilTot = nu() + 1000; markeer(n); return; }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* ==========================================================================
   Page 08 (over-ons) — decoratieve teaserloop in hn-story (taak-video-loop).
   Het <video>-element bestaat niet in de HTML: het wordt hier pas gemaakt
   wanneer [data-hn-loop] in beeld komt, en alleen vanaf 768px zonder
   prefers-reduced-motion. Mobiel haalt dus nooit een videobestand op; het
   stilbeeld (de <img> in de wrapper) blijft het LCP-element. De video ligt
   absoluut over de img heen (CSS .hn-story__loop-video) — geen layout shift.
   ========================================================================== */
(function () {
  'use strict';
  function hnInitLoops() {
    var loops = document.querySelectorAll('[data-hn-loop]');
    if (!loops.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.querySelector('video')) { io.unobserve(el); return; }
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { io.unobserve(el); return; }
        /* te smal: blijf kijken — na een resize kan een volgende intersectie alsnog starten */
        if (!window.matchMedia('(min-width: 768px)').matches) return;
        io.unobserve(el);
        var video = document.createElement('video');
        video.className = 'hn-story__loop-video';
        /* muted als property, niet alleen attribuut: bij dynamisch gemaakte
           elementen mapt het attribuut op defaultMuted en weigert Chrome autoplay */
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('preload', 'metadata');
        video.setAttribute('aria-hidden', 'true');
        video.tabIndex = -1;
        /* currentSrc is leeg zolang de lazy img nog niet geladen is — val
           terug op src, zodat de poster altijd gezet is (eis uit de taak) */
        var img = el.querySelector('img');
        if (img) video.poster = img.currentSrc || img.src;
        if (el.dataset.webm) {
          var sw = document.createElement('source');
          sw.src = el.dataset.webm;
          sw.type = 'video/webm';
          video.appendChild(sw);
        }
        var sm = document.createElement('source');
        sm.src = el.dataset.mp4;
        sm.type = 'video/mp4';
        video.appendChild(sm);
        el.appendChild(video);
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* decoratief — stil falen */ });
      });
    });
    loops.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hnInitLoops);
  } else {
    hnInitLoops();
  }
})();


/* ==========================================================================
   A1 (header) — compact-zoekknop (mobiel, sticky staat): klapt de vendor-
   zoekrij uit/in. CSS in hem-nature.css §A1 bepaalt de zichtbaarheid.
   ========================================================================== */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    /* 7 okt: twee selectors, want de desktopknop draagt de basisklasse niet
       meer — die zette hem onder 1024px per ongeluk aan. Zie hn-header.liquid. */
    var btn = e.target.closest('.hn-hdr-search-toggle, .hn-hdr-search-toggle--desktop');
    if (!btn) return;
    var sticky = document.getElementById('sticky-header');
    if (!sticky) return;
    var open = sticky.classList.toggle('hn-search-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var input = document.getElementById('header-search-in-modal');
      if (input) setTimeout(function () { input.focus(); }, 50);
    }
  });
})();


/* ==========================================================================
   B-01 (homepage) — voor/na-labels onder de foto op mobiel (render 01).
   De voor-label zit in de geclipte linkerhelft van de image-comparison;
   daarom verplaatsen we beide labels eenmalig naar een rij onder het beeld.
   ========================================================================== */
(function () {
  'use strict';
  /* D16 (ronde 2b, 29 aug) — herbouwd. Eerdere opzet VERPLAATSTE de labels en
     deed dat alleen onder 768px. Dat maakte het resultaat afhankelijk van
     wannéér de code draaide: laadde de pagina breed (devtools opent vaak op
     desktopmaat) of hydrateerde de vergelijkingssectie later, dan liep de run
     leeg en bleven de labels in hun geclipte helft staan — onzichtbaar. Precies
     het gemelde beeld, en niet te reproduceren met alleen een smalle viewport.

     Nu wordt er GEKLOOND in plaats van verplaatst, zonder breedtecheck: de
     originelen blijven staan (desktop) en de kopie komt onder de foto (mobiel).
     Welke van de twee zichtbaar is, bepaalt CSS. De DOM is daardoor in elke
     volgorde en op elke breedte hetzelfde, dus timing kan het niet meer breken.
     De kopie is aria-hidden; de originelen houden de semantiek. */
  function hnCompareLabels() {
    document.querySelectorAll('[id*="image_comparison"]').forEach(function (sec) {
      if (sec.querySelector('.hn-ba-labels')) return;
      var before = sec.querySelector('[class*="heading-before-"]');
      var after = sec.querySelector('[class*="heading-after-"]');
      var img = sec.querySelector('[class*="main-img-"]');
      if (!before || !after || !img) return;
      var row = document.createElement('div');
      row.className = 'hn-ba-labels';
      row.setAttribute('aria-hidden', 'true');
      row.appendChild(before.cloneNode(true));
      row.appendChild(after.cloneNode(true));
      /* Ronde 4 (12 sep): de rij ging hiervoor direct achter de foto, en dat is
         BINNEN `.ic-image`. Die container draagt `overflow-hidden` (voor de
         ronde hoeken en voor de geklipte helft van de vergelijking), dus alles
         wat onder de foto uitsteekt wordt weggesneden — de rij dus. Dat is de
         "voor/na-labels onzichtbaar" uit de doorloop. De rij gaat nu achter
         `.ic-image` zelf staan, als broer, en valt daarmee buiten de klip.
         Zonder `.ic-image` (andere sectievariant) blijft het oude gedrag. */
      var doos = sec.querySelector('.ic-image') || img;
      doos.insertAdjacentElement('afterend', row);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hnCompareLabels);
  } else {
    hnCompareLabels();
  }
  window.addEventListener('load', hnCompareLabels);
  /* de sectie hydrateert via x-intersect; een observer vangt dat af zonder
     op vaste timeouts te gokken */
  if ('MutationObserver' in window) {
    var kijker = new MutationObserver(function () { hnCompareLabels(); });
    kijker.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', function () { setTimeout(function () { kijker.disconnect(); hnCompareLabels(); }, 6000); });
  }
})();

/* ===== B-02: keurmerken desktop onder de productfoto (render 02c) =====
   De keurmerken zitten als html-block in de buy box (mobiele positie klopt);
   op >=768px horen ze onder de galerij in de mediakolom. CSS alleen kan een
   element niet tussen kolommen verplaatsen, dus een kleine verhuis-functie
   met anker om bij terugschalen de oorspronkelijke plek te herstellen. */
(function () {
  /* D20-HERZIENING (1 sep). Deze functie draaide drie keer — op
     DOMContentLoaded, op `load` en nog eens 1,5s ná `load` — omdat hij het blok
     in `.product-media-container > .sticky` plaatste, en die sticky-wrapper
     wordt pas door de galerij-hydratie gemaakt. Tussen die aanroepen stond het
     blok dus in de verkeerde kolom, en verschoof de hele infokolom ~101px.
     Gemeten gevolg: paginahoogte wisselde tussen 3550 en 3454px op de ene PDP,
     en op de andere stond de koopknop de ene opname op y 847 en de volgende
     niet.

     Zuivere CSS-ordening kan dit niet oplossen: het blok zit genest in de
     infokolom, en `order`/grid werkt alleen tussen broers en zussen binnen
     dezelfde container. De PDP-sectie is bovendien vendorcode
     (`main-product.liquid`), die we niet herstructureren.

     Wat het wél oplost: mikken op `.product-media-container` zelf. Die staat
     gewoon in de server-HTML, dus de plaatsing lukt meteen bij
     DOMContentLoaded en hoeft nooit herhaald te worden. Gemeten: het blok
     overleeft de hydratie, belandt daarna vanzelf ín de sticky-wrapper (die
     wordt rond de bestaande kinderen gebouwd), staat op dezelfde y=797 als
     voorheen, en is vanaf 300ms onveranderd. Geen `load`-herhalingen meer, dus
     geen venster waarin de pagina anders is opgemaakt. */
  function hnMoveCerts(forceer) {
    /* scope op de main-sectie: de quick-view-aside heeft een eigen (verborgen)
       .product-media-container die anders als eerste matcht */
    var main = document.querySelector('section[id*="__main"] .product-info')?.closest('section[id*="__main"]') || document.querySelector('[id*="__main"].shopify-section');
    if (!main) return false;
    /* Geen globale terugval meer (4 sep). `|| document.querySelector(...)` zocht
       het keurmerkblok desnoods buiten de hoofdsectie op. Dat is vandaag alleen
       ongevaarlijk bij toeval: op de homepage is `main` null en wordt de
       terugval nooit bereikt — maar die pagina heeft wél een
       `.product-media-container` (het uitgelichte product), dus zodra daar ooit
       een sectie met `__main` in het id verschijnt, zou de functie een
       keurmerkblok van elders die kolom in trekken. Scope hoort scope te zijn. */
    var wrapper = main.querySelector('.keurmerken-wrapper');
    var blok = wrapper && wrapper.closest('.custom-html');
    var media = main.querySelector('.product-media-container');
    if (!blok || !media) return false;
    /* De galerij zit in een sticky wrapper; daarbinnen plaatsen zodat de
       keurmerken met de foto meebewegen in plaats van eronderdoor te scrollen.
       Die wrapper staat NIET in de server-HTML: de galerij-hydratie bouwt hem
       om de bestaande kinderen heen. Plaatsen we het blok ervoor, dan valt het
       er naderhand buiten — gemeten: blok in .product-media-container maar
       inSticky false, en check-b02 ("keurmerken in sticky mediakolom") viel om.
       Dat verschil is ook ~96px in de sectiehoogte waard. Daarom wachten we op
       de wrapper (zie hnStartCerts); alleen een geforceerde aanroep valt terug
       op de container zelf. */
    var sticky = media.querySelector(':scope > .sticky');
    if (sticky) media = sticky;
    else if (!forceer) return false;
    if (!blok.hnCertsAnker) {
      var anker = document.createComment('hn-certs-anker');
      blok.parentNode.insertBefore(anker, blok);
      blok.hnCertsAnker = anker;
    }
    var naarMedia = window.matchMedia('(min-width: 768px)').matches;
    if (naarMedia && !media.contains(blok)) {
      media.appendChild(blok);
    } else if (!naarMedia && media.contains(blok)) {
      blok.hnCertsAnker.parentNode.insertBefore(blok, blok.hnCertsAnker.nextSibling);
    }
    return true;
  }
  /* Eén poging. Lukt die niet — het script kan draaien voordat de
     mediacontainer geparst is — dan wacht een observer tot hij er is en stopt
     daarna meteen. Dat vervangt de oude herhalingen op `load` en `load+1500`:
     het blok wordt precies één keer geplaatst, zonder venster waarin de pagina
     anders is opgemaakt. Zonder dit vangnet miste de plaatsing af en toe
     helemaal en verschoof de infokolom alsnog 96px. */
  function hnStartCerts() {
    if (hnMoveCerts()) { document.documentElement.dataset.hnCerts = 'direct'; return; }
    /* Alleen wachten waar er iets te wachten valt. Het keurmerkblok staat in de
       server-HTML van de productpagina; bestaat het niet, dan komt het ook niet
       meer. Zonder deze poort draaide er op ELKE andere pagina tien seconden
       lang een document-brede observer voor niets — gemeten op de homepage:
       162 aanroepen, 303 records, ~30ms hoofddraadtijd, resultaat nul. */
    if (!document.querySelector('.keurmerken-wrapper')) return;
    document.documentElement.dataset.hnCerts = 'wachten';
    var kijker = new MutationObserver(function () {
      if (hnMoveCerts()) { kijker.disconnect(); document.documentElement.dataset.hnCerts = 'observer'; }
    });
    kijker.observe(document.documentElement, { childList: true, subtree: true });
    /* Nooit eeuwig blijven kijken. Komt de sticky-wrapper er niet, dan alsnog
       in de mediacontainer plaatsen — beter daar dan in de infokolom. */
    setTimeout(function () {
      kijker.disconnect();
      if (document.documentElement.dataset.hnCerts === 'wachten') {
        hnMoveCerts(true);
        document.documentElement.dataset.hnCerts = 'geforceerd';
      }
    }, 10000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hnStartCerts);
  } else {
    hnStartCerts();
  }
  window.matchMedia('(min-width: 768px)').addEventListener('change', function () { hnMoveCerts(true); });
})();

/* ===== B-02: how-to-video autoplay + loop (docs/taak-video-loop.md) =====
   De video in hn-how-to heeft geen src in de HTML; de bron gaat er pas in
   wanneer het blok in beeld komt en de bezoeker geen reduced motion heeft.
   Buiten beeld pauzeert de loop.

   HERZIENING D24 (ronde 2, 29 aug): de 768px-grens is eruit. taak-video-loop.md
   schreef "alleen laden vanaf 768px, mobiel alleen de poster" en zo stond het
   sinds blok B; de eigenaar meldt in ronde 2 dat de video op de mobiele
   productpagina niet afspeelt en rekent dat als bug. Mobiel speelt nu dus mee.
   Alle andere waarborgen blijven: poster als LCP-element, preload metadata,
   muted, pas bij intersectie, reduced-motion respecteren. LCP-effect gemeten
   en gerapporteerd. */
(function () {
  function hnHowtoVideo() {
    var video = document.querySelector('.hn-howto__video');
    if (!video || video.dataset.hnInit || !('IntersectionObserver' in window)) return;
    video.dataset.hnInit = '1';
    var rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) {
          if (!video.paused) video.pause();
          return;
        }
        if (rustig.matches) return;
        if (!video.dataset.hnLoaded) {
          video.querySelectorAll('source[data-src]').forEach(function (s) {
            s.src = s.dataset.src;
          });
          video.load();
          video.dataset.hnLoaded = '1';
        }
        video.muted = true;
        var poging = video.play();
        if (poging && poging.catch) poging.catch(function () {});
      });
    }, { rootMargin: '100px' });
    io.observe(video);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hnHowtoVideo);
  } else {
    hnHowtoVideo();
  }
})();

/* ===== B-02: "1/8"-teller op de mobiele productgalerij (render 02) =====
   Splide rendert puntjes (pagination aan in hn-media-gallery); de teller-chip
   leest de actieve punt uit en volgt wisselingen via een MutationObserver —
   geen greep in de splide-instantie nodig. */
(function () {
  function hnFotoTeller() {
    var galerij = document.querySelector('[id^="x-product-"].swiper-product');
    if (!galerij || galerij.dataset.hnTeller) return;
    var dots = galerij.querySelector('.splide__pagination');
    if (!dots) return;
    galerij.dataset.hnTeller = '1';
    var chip = document.createElement('div');
    chip.className = 'hn-foto-teller';
    chip.setAttribute('aria-hidden', 'true');
    galerij.appendChild(chip);
    var update = function () {
      var alle = dots.querySelectorAll('.splide__pagination__page');
      if (alle.length < 2) { chip.style.display = 'none'; return; }
      var actief = 0;
      alle.forEach(function (d, i) { if (d.classList.contains('is-active')) actief = i; });
      chip.textContent = (actief + 1) + ' / ' + alle.length;
    };
    update();
    new MutationObserver(update).observe(dots, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }
  var start = function () {
    hnFotoTeller();
    var g0 = document.querySelector('[id^="x-product-"].swiper-product');
    if (!g0) return;
    if (g0.dataset.hnTeller) return;
    /* splide hydrateert pas als de galerij in beeld komt en kan het element
       daarbij vervangen; kijk daarom op body-niveau en query opnieuw in de
       callback, stop zodra de chip er staat */
    var kijker = new MutationObserver(function () {
      hnFotoTeller();
      var g = document.querySelector('[id^="x-product-"].swiper-product');
      if (g && g.dataset.hnTeller) kijker.disconnect();
    });
    kijker.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ===== B-02: Judge.me mobiel — schrijf-CTA onder de kaarten (render 02) =====
   De "Schrijf een beoordeling"-knop zit in de widget-header; de render zet hem
   onder de kaartenslider, boven de paginering. Zelfde verhuispatroon als de
   keurmerken: anker terug bij >=768px. De widget hydrateert laat, dus een
   observer wacht tot hij er staat. */
(function () {
  function hnJmMobiel() {
    var widg = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg');
    if (!widg) return false;
    var acties = widg.querySelector('.jdgm-widget-actions-wrapper');
    var reviews = widg.querySelector('.jdgm-rev-widg__reviews');
    if (!acties || !reviews) return false;
    if (!acties.hnJmAnker) {
      var anker = document.createComment('hn-jm-anker');
      acties.parentNode.insertBefore(anker, acties);
      acties.hnJmAnker = anker;
    }
    var mobiel = !window.matchMedia('(min-width: 768px)').matches;
    if (mobiel && acties.previousElementSibling !== reviews) {
      reviews.after(acties);
    } else if (!mobiel && acties.hnJmAnker.parentNode && acties.previousSibling !== acties.hnJmAnker) {
      acties.hnJmAnker.parentNode.insertBefore(acties, acties.hnJmAnker.nextSibling);
    }
    return true;
  }
  var start = function () {
    if (hnJmMobiel()) return;
    var kijker = new MutationObserver(function () {
      if (hnJmMobiel()) kijker.disconnect();
    });
    kijker.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.matchMedia('(min-width: 768px)').addEventListener('change', hnJmMobiel);
})();

/* ===== PDP desktop: "Alle N reviews lezen" naar rechtsonder (7 okt 2026) =====

   De knop stond links onderaan: sections/hn-review-cta is een eigen sectie
   ónder het Judge.me-widget, en omdat de knop links uitlijnt kwam hij uit
   onder het sorteerveld — net alsof hij bij de linkerkolom hoorde. De
   eigenaar wil hem op desktop aan het eind van de reviewlijst: onder de
   paginanummers, rechts uitgelijnd. Daar is de bezoeker als hij door de
   reviews heen is.

   WAAROM DIT NIET MET CSS KAN
   De knop zit in een ándere Shopify-sectie dan het widget. Geen enkele
   CSS-regel kan een element in het raster van een andere sectie plaatsen, en
   het met een negatieve marge omhoog schuiven zou afhangen van de hoogte van
   het sorteerblok — dat is inhoud die kan teruglopen over twee regels.

   WAAROM NAAST .jdgm-rev-widg__body EN NIET ERIN
   Het ligt voor de hand de knop achter de paginering te hangen, binnen de
   rechterkolom. Dat gaat stuk: paginering en sorteren laten Judge.me de
   widget opnieuw renderen (zie het blok hieronder over de rangschikking), en
   dan is alles ín die kolom weg. De knop wordt daarom een kind van het
   raster zelf, in rij 2 kolom 2 — naast het sorteerblok, dat in rij 2 kolom 1
   staat. Plaatsing gebeurt in CSS; hier wordt alleen verhuisd.

   EN TOCH KAN HIJ VERDWIJNEN. Een herrender kan het hele raster vervangen.
   Daarom wordt de knop éénmaal opgezocht en in `knop` vastgehouden: een
   losgekoppeld element blijft bestaan zolang er een verwijzing naar is, dus
   kan hij er altijd weer in. De observer blijft om die reden aan staan, net
   als bij de rangschikkingsregel; het werk is idempotent.

   Zelfde verhuispatroon als de keurmerken en de schrijf-CTA: een
   commentaaranker onthoudt de oorspronkelijke plek, zodat mobiel exact blijft
   zoals het was. Grens op 1024px, want daar schakelt het widget zelf van twee
   kolommen naar één (zie .jdgm-rev-widg in assets/hem-nature.css). */
(function () {
  var knop = null;
  var anker = null;

  function hnRctaPlek() {
    if (!knop) {
      knop = document.querySelector('.hn-rcta');
      if (!knop) return false;
      anker = document.createComment('hn-rcta-anker');
      knop.parentNode.insertBefore(anker, knop);
    }
    var widg = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg');
    var desktop = window.matchMedia('(min-width: 1024px)').matches;

    if (desktop && widg) {
      if (knop.parentNode !== widg) {
        widg.appendChild(knop);
        knop.classList.add('hn-rcta--in-widget');
      }
      return true;
    }
    /* Mobiel, of het widget is er nog niet: terug naar de eigen sectie. */
    if (anker.parentNode && knop.previousSibling !== anker) {
      anker.parentNode.insertBefore(knop, anker.nextSibling);
      knop.classList.remove('hn-rcta--in-widget');
    }
    return !!widg;
  }

  var start = function () {
    hnRctaPlek();
    var kijker = new MutationObserver(function () { hnRctaPlek(); });
    kijker.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.matchMedia('(min-width: 1024px)').addEventListener('change', hnRctaPlek);
})();

/* ===== RONDE 6 / B6 (3 okt 2026): zeggen waarop de reviews gerangschikt zijn
   =====

   Wie reviews in een niet-neutrale volgorde toont, hoort te zeggen waarop
   gerangschikt wordt. Dat is de kern van de omnibusregels, en het is het
   enige deel van B6 dat in het thema thuishoort.

   DE SORTERING ZELF STAAT IN HET JUDGE.ME-DASHBOARD. Hier stond eerst code
   die de dropdown na het laden op "Hoogste beoordeling" zette. Dat werkte,
   maar het is een omweg: de widget kwam binnen op de oude volgorde en
   sorteerde daarna zichtbaar om. De eigenaar heeft de standaardsortering in
   het dashboard gezet, dus die omweg is weg.

   DE VERMELDING STAAT BIJ HET VELD, niet in een voetnoot: `.jdgm-row-actions`
   is een flexkolom met alleen de sorteerdropdown erin, dus een regel eronder
   landt precies waar de bezoeker de volgorde kan veranderen.

   EN HIJ CONTROLEERT ZICHZELF. De zin beweert iets — "standaard gesorteerd op
   hoogste beoordeling" — en die bewering wordt getoetst aan wat de widget
   werkelijk als eerste oplevert. Staat het dashboard ooit op iets anders, of
   draait een app-update het terug, dan verdwijnt de zin in plaats van te
   liegen. Een vermelding die niet klopt is erger dan geen vermelding.

   De eerste waarde die de dropdown toont ís de standaard; wat de bezoeker
   daarna kiest verandert daar niets aan, en de zin blijft dan ook terecht
   staan. Vandaar dat `standaard` maar één keer gezet wordt. */
(function () {
  var VERMELDING = 'Standaard gesorteerd op hoogste beoordeling. Je kunt de volgorde hierboven zelf aanpassen.';
  var standaard = null;

  function hnJmRangschikking() {
    var wrap = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg__sort-wrapper');
    if (!wrap) return false;
    var sel = wrap.querySelector('select.jdgm-sort-dropdown');
    if (!sel) return false;
    var rij = wrap.parentNode;
    if (!rij) return false;

    if (standaard === null) standaard = sel.value;

    /* Het verborgen label is van Judge.me en staat in het Engels. Een
       schermlezer leest dat voor op een Nederlandse pagina. */
    var label = wrap.querySelector('.jdgm-sort-dropdown-label');
    if (label && /sort by/i.test(label.textContent)) {
      label.textContent = 'Sorteren op';
    }

    var bestaand = rij.querySelector('.hn-jm-rangschikking');
    if (standaard === 'highest-rating') {
      if (!bestaand) {
        var regel = document.createElement('p');
        regel.className = 'hn-jm-rangschikking';
        regel.textContent = VERMELDING;
        rij.appendChild(regel);
      }
    } else if (bestaand) {
      bestaand.remove();
    }
    return true;
  }

  var start = function () {
    hnJmRangschikking();
    /* Niet afkoppelen na de eerste keer: sorteren rendert de widget opnieuw
       en dan moet de vermelding er weer in. De observer is goedkoop en het
       werk is idempotent. */
    var kijker = new MutationObserver(function () { hnJmRangschikking(); });
    kijker.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/* ==========================================================================
   Zoeksuggesties — limiet per soort in plaats van één totaalbudget (4 sep).

   Het paneel toonde op mobiel één product waar desktop er vier gaf. Oorzaak:
   xModalSearch (theme.js) vraagt `resources[type]=query,product,article` met
   één `resources[limit]`, en Shopify behandelt die limiet dan als totaal over
   alle soorten samen. Op mobiel (limiet 3) aten twee zoeksuggesties twee van de
   drie plaatsen op. Empirisch bevestigd op deze shop:

     type=query,product,article & limit=3                  -> 2 queries, 1 product
     type=query,product,article & limit=3 & limit_scope=each -> 2 queries, 3 producten

   De request zit in theme.js en dat is vendorcode, dus we hangen de parameter
   er hier aan. Alleen voor /search/suggest, alleen als hij er nog niet staat,
   en Request-objecten laten we ongemoeid.
   ========================================================================== */
(function () {
  'use strict';
  if (typeof window.fetch !== 'function') return;
  var origineel = window.fetch;

  function metScope(url) {
    try {
      var u = new URL(url, window.location.origin);
      if (!/\/search\/suggest(\.json)?$/.test(u.pathname)) return null;
      if (u.searchParams.has('resources[limit_scope]')) return null;
      u.searchParams.set('resources[limit_scope]', 'each');
      return u.toString();
    } catch (e) {
      return null;
    }
  }

  window.fetch = function (bron, opties) {
    if (typeof bron === 'string' || bron instanceof URL) {
      var aangepast = metScope(String(bron));
      if (aangepast) return origineel.call(this, aangepast, opties);
    }
    return origineel.apply(this, arguments);
  };
})();


/* ==========================================================================
   Kaartbeelden — vangnet voor het zichtbaar maken (5 sep 2026).

   De productkaart toont haar hoofdbeeld pas als de wrapper
   `.animate_transition_card__image` BEIDE klassen `active` en `lazy_active`
   draagt; tot die tijd staat hij op opacity 0 en zie je het crèmekleurige
   beeldvlak (--hn-cream-3) eronder.

   Die klassen komen uit twee onafhankelijke paden, en allebei kunnen ze missen:
     1. card-product.liquid r255: een Alpine `x-intersect`. Alpine laadt via
        deferScriptLoad pas na de eerste interactie, of na 2s.
     2. card-product.liquid r413/450: een inline `onload` met 250ms vertraging.
        Bij een afbeelding die al uit cache komt is die load al geweest.

   De eigenaar mat in zijn browser opacity 0 op het hoofdbeeld terwijl de
   pagina volledig geladen was. Hier is dat niet te reproduceren (koude én
   warme cache, drie laadbeurten, alle kaarten opacity 1) — maar de race is
   echt en dit vangnet kost niets: het zet alleen de eindtoestand, en alleen
   voor beelden die al geladen zijn.
   ========================================================================== */
(function () {
  'use strict';

  function activeer(wrap) {
    if (!wrap || (wrap.classList.contains('active') && wrap.classList.contains('lazy_active'))) return;
    var img = wrap.querySelector('img');
    if (!img) return;
    if (img.complete && img.naturalWidth > 0) {
      wrap.classList.add('active', 'lazy_active');
      wrap.classList.remove('animate-Xpulse', 'skeleton-image');
    } else {
      img.addEventListener('load', function () {
        wrap.classList.add('active', 'lazy_active');
        wrap.classList.remove('animate-Xpulse', 'skeleton-image');
      }, { once: true });
    }
  }

  function sweep() {
    document.querySelectorAll('.animate_transition_card__image').forEach(activeer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }
  window.addEventListener('load', sweep);

  /* Het collectiegrid en de zoekpagina vervangen kaarten via AJAX bij het
     filteren; nieuwe kaarten moeten dezelfde behandeling krijgen. */
  var wacht = null;
  new MutationObserver(function () {
    clearTimeout(wacht);
    wacht = setTimeout(sweep, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ==========================================================================
   Zoekveld in de header houdt de zoekterm vast (ronde 4, 12 sep)

   Op /search?q=wasmiddel stond het veld leeg met alleen de placeholder, terwijl
   twee verborgen velden (0x0) de term wél droegen. De vendor zet in
   `snippets/header-search-item.liquid` letterlijk `value=""` op het zichtbare
   veld.

   Waarom hier en niet in Liquid: dat is een vendorsnippet, en een fork voor één
   attribuut weegt niet op tegen zes regels in ons eigen bestand. De term komt
   uit de URL, niet uit de DOM, zodat het ook klopt als de vendor het veld later
   opnieuw opbouwt.
   ========================================================================== */
(function () {
  'use strict';
  function vulZoekterm() {
    var q = new URLSearchParams(window.location.search).get('q');
    if (!q) return;
    var veld = document.getElementById('header-search-in-modal');
    if (veld && !veld.value) veld.value = q;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vulZoekterm);
  } else {
    vulZoekterm();
  }
})();

/* RONDE 6 / B7 — EIGEN AFKAPPING WEER WEG (3 okt 2026)
   Hier stond een eigen inkorter voor lange reviews: vijf regels, met een
   "Lees meer"-knop die alleen verscheen als de tekst werkelijk overliep.
   Judge.me heeft daar zelf een instelling voor, en die staat nu aan op
   dezelfde vijf regels — de waarde die uit de meting kwam (mediaan drie
   regels, uitschieter veertien).

   De meting die ertoe leidde blijft het onthouden waard, want die bepaalt
   of vijf nog klopt als het aanbod verandert: vijf reviews op 1360 breed
   gaven 6, 12, 140, 286 en 537 tekens, oftewel 1, 1, 3, 8 en 14 regels, met
   de langste kaart op 310px naast kaarten van 19px.

   TWEE DINGEN OM IN DE GATEN TE HOUDEN bij hun versie, en het waren precies
   de redenen om het eerst zelf te bouwen: de knoptekst in het Nederlands, en
   geen verloop onder de afkap (non-negotiable 4). Allebei geborgd in
   check-jdgm, zodat het opvalt als een update van de app het terugdraait. */

/* ===== RONDE 6 / F1 (3 okt 2026): aftelbalk =====
   Het eindmoment komt uit Liquid en staat als absolute epoch-tijd in
   data-eind. Dit script rekent dus niet uit wánneer de actie afloopt — dat is
   serverzijdig in de winkeltijdzone gebeurd — maar telt alleen het verschil
   met de klok van nu af. Een bezoeker die zijn tijdzone verzet, verlengt de
   actie daarmee niet.

   data-nu draagt de servertijd van het moment van renderen. Het verschil met
   de browserklok is de afwijking van die laatste; die wordt er één keer uit
   gerekend, zodat een scheef gezette computer geen scheve teller geeft. Bij
   een gecachete pagina kan data-nu oud zijn, en juist dán is die correctie
   nodig.

   OP NUL VERDWIJNT ER IETS, EN WÁT verschilt per plek. Dat staat in
   data-hn-aftellen op het element zelf:
     "zelf"   — alleen de teller verdwijnt. Zo staat hij in een hero-slide: de
                slide blijft, alleen het blokje gaat eruit.
     anders   — de hele sectie verdwijnt (de oude aankondigingsbalk).
   Hij wordt écht verwijderd en niet op display:none gezet: een verborgen
   element dat nog marge of rand draagt laat een streep witruimte achter.

   6 okt: MEERDERE TELLERS OP ÉÉN PAGINA. Dit stond op querySelector — één
   element. In een slideshow kan elke slide een eigen countdown hebben, en dan
   liep alleen de eerste. Nu querySelectorAll met een eigen tikker per teller,
   zodat twee slides met verschillende einddata allebei kloppen.

   Draait de bezoeker al op de pagina als het aflopen, dan schuift de rest
   omhoog. Dat is onvermijdelijk — er verdwijnt immers iets — maar het gebeurt
   één keer en niet bij iedere tik. */
(function () {
  /* 6 okt: voorloopnul. De teller staat sinds vandaag in blokjes met een vaste
     breedte, en daar hoort "09" en niet "9". Liquid zet die nul er al in bij
     het renderen; dit houdt hem erin bij elke tik. Niet met padStart: dit
     script is bewust ES5, zoals de rest van dit bestand. */
  function tweeCijfers(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /* Welke tellers al lopen. NIET met een attribuut op het element: Splide
     kloont de slide met cloneNode en dan draagt de kopie die markering ook,
     waardoor juist de kloon zichzelf zou overslaan — precies de fout die dit
     moet oplossen. Een lijst met verwijzingen heeft dat probleem niet. */
  var lopen = [];

  var scheefGlobaal = null;
  function scheefheid(serverNu) {
    if (!serverNu) return 0;
    if (scheefGlobaal === null) scheefGlobaal = Date.now() - serverNu;
    return scheefGlobaal;
  }

  function koppel(teller) {
    if (lopen.indexOf(teller) !== -1) return;
    lopen.push(teller);

    var eind = Number(teller.getAttribute('data-eind')) * 1000;
    var serverNu = Number(teller.getAttribute('data-nu')) * 1000;
    if (!eind) return;

    /* Afwijking van de browserklok ten opzichte van de server, één keer
       bepaald bij het laden — en wel voor de hele pagina, niet per teller.
       Per teller ging mis zodra de klonen erbij kwamen: die worden later
       gekoppeld, dus werd hun afwijking later gemeten en slikte die de
       tussentijd op. Gemeten gevolg: de klonen stonden 5 seconden achter op de
       echte slides. Alle tellers komen uit dezelfde paginalading en hebben
       dus dezelfde data-nu; één gezamenlijke afwijking is daarom juist. */
    var scheef = scheefheid(serverNu);

    var d = teller.querySelector('[data-hn-d]');
    var u = teller.querySelector('[data-hn-u]');
    var m = teller.querySelector('[data-hn-m]');
    var s = teller.querySelector('[data-hn-s]');
    var tikker = null;

    function weg() {
      if (tikker) clearInterval(tikker);
      if (teller.getAttribute('data-hn-aftellen') === 'zelf') {
        if (teller.parentNode) teller.parentNode.removeChild(teller);
        return;
      }
      var sectie = teller.closest('.section-hn-aftelbalk') || teller.parentNode;
      if (sectie && sectie.parentNode) {
        sectie.parentNode.removeChild(sectie);
      } else if (teller.parentNode) {
        teller.parentNode.removeChild(teller);
      }
    }

    function tik() {
      var over = Math.floor((eind - (Date.now() - scheef)) / 1000);
      if (over <= 0) { weg(); return; }
      var dag = Math.floor(over / 86400);
      var uur = Math.floor((over % 86400) / 3600);
      var min = Math.floor((over % 3600) / 60);
      var sec = over % 60;
      if (d) d.textContent = tweeCijfers(dag);
      if (u) u.textContent = tweeCijfers(uur);
      if (m) m.textContent = tweeCijfers(min);
      if (s) s.textContent = tweeCijfers(sec);
    }

    tik();
    tikker = setInterval(tik, 1000);
  }

  function scan() {
    var tellers = document.querySelectorAll('[data-hn-aftellen], [data-hn-aftelbalk]');
    for (var i = 0; i < tellers.length; i++) koppel(tellers[i]);
  }

  /* 6 okt, GEMETEN FOUT: DE KLONEN VAN DE SLIDESHOW STONDEN STIL.
     Splide maakt voor het rondlopen kopieën van de slides, en dat doet hij ná
     DOMContentLoaded. De teller werd dus één keer aan de echte slides gehangen
     en de kopieën bleven staan op de seconde van het klonen. Gemeten op de
     preview: drie echte slides liepen van 34 naar 32, de vier klonen bleven
     allemaal op 19 staan. Een bezoeker die doorswipet zag een bevroren teller
     die ook nooit zou verdwijnen.

     Dit zat er vanaf de eerste versie in; het viel niet op omdat er toen op de
     eerste slide werd gemeten en dat is een echte, geen kloon.

     Daarom wordt er opnieuw gescand zodra er een teller aan de pagina wordt
     toegevoegd. De waarnemer kijkt alleen of er een teller bij zit en doet
     anders niets, zodat hij niet bij elke DOM-wijziging aan het werk gaat. */
  function nieuweTellers(lijst) {
    for (var i = 0; i < lijst.length; i++) {
      var bij = lijst[i].addedNodes;
      for (var j = 0; j < bij.length; j++) {
        var n = bij[j];
        if (!n || n.nodeType !== 1) continue;
        if (n.hasAttribute('data-hn-aftellen') || n.hasAttribute('data-hn-aftelbalk')) return true;
        if (n.querySelector && n.querySelector('[data-hn-aftellen], [data-hn-aftelbalk]')) return true;
      }
    }
    return false;
  }

  function start() {
    scan();
    if (!window.MutationObserver) return;
    new MutationObserver(function (lijst) {
      if (nieuweTellers(lijst)) scan();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ===== INCI-modal op de productpagina (14 okt 2026) =====
 *
 * De trigger staat in de tekst van het Ingrediënten-tabblad (een
 * liquid-setting in templates/product.json), de modal onderaan
 * sections/hn-product-tabs.liquid. Allebei achter dezelfde voorwaarde: geen
 * metaveld, geen trigger en geen modal.
 *
 * WAT DE BROWSER AL DOET bij <dialog> + showModal(): Esc sluit, de focus komt
 * in de modal en blijft erin, de rest van de pagina wordt inert, en ::backdrop
 * tekent de achtergrond. Dat is precies de reden voor <dialog> in plaats van
 * een eigen laag met een zelfgebouwde focusval.
 *
 * WAT DE BROWSER NIET DOET, en hier dus staat:
 *  - de pagina eronder stilzetten (showModal laat die gewoon doorscrollen);
 *  - de focus terugzetten op de trigger die hem opende;
 *  - sluiten bij een klik op de achtergrond.
 *
 * De koppeling loopt via data-attributen en niet via een href of een
 * artikelnaam: er is één modal per pagina en elke trigger opent diezelfde.
 */
(function () {
  var modal = null;
  var opener = null;
  var scrollVast = '';

  function open(trigger) {
    if (!modal || modal.open) return;
    opener = trigger;
    scrollVast = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    modal.showModal();
  }

  function naSluiten() {
    document.documentElement.style.overflow = scrollVast;
    /* Terug naar de knop die hem opende. Zonder dit staat de focus na het
       sluiten op <body> en begint toetsenbordnavigatie weer bovenaan. */
    if (opener && document.contains(opener)) opener.focus();
    opener = null;
  }

  function start() {
    modal = document.querySelector('[data-hn-inci-modal]');
    if (!modal) return;

    /* Geen showModal() in een browser die het niet kent: dan blijft de modal
       dicht en gebeurt er niets, in plaats van een halve laag over de pagina. */
    if (typeof modal.showModal !== 'function') return;

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest ? e.target.closest('[data-hn-inci-open]') : null;
      if (trigger) { e.preventDefault(); open(trigger); return; }
      if (e.target.closest && e.target.closest('[data-hn-inci-sluit]')) { modal.close(); return; }
      /* Klik op de achtergrond. Bij een <dialog> is de backdrop geen eigen
         element: een klik erop heeft de dialog zelf als target, terwijl een
         klik op de inhoud een kind als target heeft. */
      if (e.target === modal) modal.close();
    });

    modal.addEventListener('close', naSluiten);
    /* cancel = Esc. close volgt erop, dus daar hoeft niets extra's. */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   Mandbewaker: het gratis cadeau blijft er één, en draagt _free_gift
   (14 okt 2026 — hoort bij het werk van Kite, docs/04-winkelmand-notes.md)

   WAAROM DIT BESTAAT
   Kite's eigen Liquid in sections/hn-main-cart-items en snippets/hn-cart-drawer
   herkent een cadeauregel op twee manieren:

     final_line_price == 0 (en geen cadeaubon)   -> de prijstak
     properties._free_gift of properties._gift   -> de eigenschapstak

   Hun app zet in de praktijk `_free_product`, en dat is geen van die twee
   namen. De eigenschapstak kwam dus nooit aan bod; alles leunde op de prijs.
   Deze bewaker zorgt dat `_free_gift` er wél op staat, zodat de herkenning
   ook via de bedoelde tak loopt. De blokken van Kite blijven ongemoeid — hier
   wordt geen Liquid aangeraakt, alleen de mand.

   EN BELANGRIJKER: "maximaal één" mag niet aan een verborgen knop hangen.
   Kite haalt de aantalkiezer weg, en daarmee is het via de pagina niet meer
   op te hogen. Maar /cart/change.js staat gewoon open: aantal 3 van een
   cadeau van 0,00 bleef na herladen gewoon 3 staan, want de app zet het niet
   terug. Een verborgen knop is geen regel. Deze bewaker zet het aantal van
   een cadeauregel terug naar 1, ongeacht waar de wijziging vandaan kwam.

   ──────────────────────────────────────────────────────────────────────────
   DE EIGENSCHAP WORDT ERBIJ GEZET TIJDENS HET TOEVOEGEN, NIET ACHTERAF.
   EN DAT IS NIET MOOIDOENERIJ, DAT IS GEMETEN.

   De eerste versie zette `_free_gift` erbij met /cart/change.js nadat de app
   zijn cadeau had neergelegd. Dat werkt één keer en gaat dan mis: een regel
   met andere eigenschappen krijgt van Shopify een andere regelsleutel, en
   bij de volgende paginalading herkende de app zijn eigen cadeau niet meer
   en legde er nóg een neer. Gemeten op 14 okt: twee cadeauregels in de mand,
   één mét en één zonder de eigenschap — precies het tegenovergestelde van
   wat hier de bedoeling is.

   Kan het dan wél tijdens het toevoegen? Ja: het verzoek waarmee de app zijn
   cadeau neerlegt is onderweg aan te vullen. Dat ziet er zo uit (vastgelegd
   14 okt):

     POST /cart/add.js?app=gfgfreegift
     {"items":[{"id":"55206509281623","quantity":1,"properties":{
       "_free_product":"true","_rule_id":"BUY_ANY_PRODUCT_FROM_COLLECTION_Y_0",
       "_kite_promo_name":"Sample"}}]}

   Daar komt `_free_gift` dan bij vóórdat het verzoek de deur uit gaat: de
   regel wordt mét de eigenschap aangemaakt, de sleutel verandert daarna niet
   meer, en de app blijft zijn eigen cadeau herkennen. Nagemeten en werkend.

   MAAR DAT STUK STAAT STANDAARD UIT — zie de schakelaar
   KITE_VERZOEK_AANVULLEN hieronder. Het leunt op het verzoekformaat van een
   app die wij niet in de hand hebben, en het wordt overbodig zodra onze eigen
   samples het overnemen: die zetten `_free_gift` meteen zelf neer. Zet hem
   aan als de samples voorlopig nog van Kite komen én je wilt dat hun regels
   via de eigenschapstak herkend worden.

   WAT ER DAARDOOR NIET GEBEURT: een regel van 0 euro die de app zelf heeft
   neergelegd (te herkennen aan `_free_product`, `_rule_id` of
   `_kite_promo_name`) krijgt achteraf nóóit meer een eigenschap opgeplakt.
   Stond hij er al vóór deze bewaker zonder `_free_gift`, dan blijft dat zo
   tot de mand geleegd wordt; een dubbel cadeau is erger dan een gemiste
   eigenschap. Een regel van 0 euro zónder die herkenningspunten is niet van
   de app, en die krijgt de eigenschap wél gewoon achteraf.

   Het aantal terugzetten mag altijd: dat gaat zonder `properties` mee, en
   dan laat Shopify de regelsleutel staan. Nagemeten — er kwam geen tweede
   cadeauregel bij. Dat deel hangt dus aan géén enkele schakelaar en geldt
   voor élke gratis regel: die van Kite, die van ons eigen samplewerk als dat
   er komt, en elke andere.
   ──────────────────────────────────────────────────────────────────────────

   WANNEER HIJ LOOPT
    - bij het laden van elke pagina (alleen als de mand niet leeg is);
    - na elke mandwijziging die niet van hemzelf komt — /cart/add.js,
      /cart/change.js, /cart/update.js — of die nu met fetch of met
      XMLHttpRequest gedaan wordt, en dus ook vanaf de console of vanuit een
      app;
    - na eurus:cart:items-changed, het eigen signaal van het thema.

   WAAROM HIJ NIET IN ZICHZELF RONDDRAAIT
   Hij herstelt per ronde één regel, leest de mand daarna opnieuw en stopt na
   vijf rondes. Een ronde die niets te herstellen vindt doet niets — dus zodra
   het klopt, valt hij stil, ook als een eigen aanroep hem opnieuw aanzet.

   HERRENDEREN GAAT ZOALS HET THEMA HET ZELF DOET (zie assets/theme.js
   r452-500): reRenderSections op xCartHelper, de teller uit de hertekende
   bubbel, en eurus:cart:items-changed eroverheen.
   ========================================================================== */

(function () {
  'use strict';

  var MAX_RONDES = 5;
  var eigenAanroep = false;
  var bezig = false;
  var wachtend = null;

  /* ─── SCHAKELAAR ───────────────────────────────────────────────────────
     Het aanvullen van Kite's eigen /cart/add.js-verzoek staat STANDAARD UIT.

     Waarom uit: dat stuk kent het verzoekformaat van een app die wij niet in
     de hand hebben. Vandaag ziet dat eruit als één JSON-lichaam met `items`
     en `properties`; verandert Kite dat in een volgende versie, dan werkt het
     stilletjes niet meer en merkt niemand het. Zodra onze eigen samples het
     overnemen, zet Kite er geen meer neer en is dit sowieso overbodig.

     Weggehaald is het niet, want zolang de samples nog van de Kite-app komen
     is dit het enige wat hun regels een `_free_gift` geeft — en dat is de tak
     waar hun eigen Liquid op kijkt. Staat deze schakelaar uit, dan worden hun
     cadeauregels alleen nog op prijs herkend (`final_line_price == 0`), net
     zoals vóór 14 okt. De aantalkiezer blijft dus gewoon verdwijnen.

     Wat NIET aan deze schakelaar hangt, en dus altijd werkt: het aantal van
     een cadeauregel terugzetten naar 1. Dat geldt voor élke gratis regel —
     die van Kite, die van ons eigen samplewerk, of welke andere dan ook.
     ──────────────────────────────────────────────────────────────────── */
  var KITE_VERZOEK_AANVULLEN = false;

  /* HIER IS DE GRENS BEWUST NAUWER DAN DIE VAN KITE, EN DAT MOET OOK.
     Kite's Liquid kijkt naar `final_line_price == 0` en verbergt dan een knop.
     Deze bewaker schrijft in de mand — hij plakt er een eigenschap op en zet
     het aantal terug naar 1 — en dat mag je niet doen op grond van een prijs
     die ook door een korting nul kan zijn. Deze winkel draait voortdurend
     acties als "2+1 gratis" en "1+1 wasmiddel"; de gratis regel daarvan komt
     óók op nul uit, en die hoort gewoon te blijven staan zoals de klant hem
     heeft. Vandaar `original_line_price`: de prijs van de variant zelf. Een
     echt cadeauproduct kost 0,00 (Sample INCIA Wasmiddel bijvoorbeeld), een
     weggegeven tweede fles niet.
     Zo'n kortingsregel verliest zijn aantalkiezer nog steeds — dat doet Kite's
     Liquid — maar daar wordt hier niets aan veranderd; het staat als bevinding
     in docs/04-winkelmand-notes.md en hoort bij de app. */
  function isCadeau(regel) {
    if (!regel || regel.gift_card) return false;
    if (regel.original_line_price === 0) return true;
    var p = regel.properties || {};
    return !!(p._free_gift || p._gift || p._free_product);
  }

  /* De herkenningspunten die de app zelf meestuurt. Een regel die deze draagt
     is van de app, en daar worden de eigenschappen niet meer van aangeraakt;
     zie de uitleg hierboven. */
  function vanDeApp(eigenschappen) {
    var p = eigenschappen || {};
    return !!(p._free_product || p._rule_id || p._kite_promo_name);
  }

  function heeftVlag(eigenschappen) {
    var p = eigenschappen || {};
    return String(p._free_gift || '') !== '';
  }

  function aantalMoetTerug(regel) {
    return isCadeau(regel) && regel.quantity > 1;
  }

  function vlagMagErbij(regel) {
    return isCadeau(regel) && !heeftVlag(regel.properties) && !vanDeApp(regel.properties);
  }

  function moetHersteld(regel) {
    return aantalMoetTerug(regel) || vlagMagErbij(regel);
  }

  /* DE VLAG STAAT ALLEEN OP TIJDENS DE AANROEP ZELF, NIET TIJDENS HET WACHTEN.
     Eerst werd `eigenAanroep` pas in de .then weer uitgezet. Daarmee stond hij
     een halve seconde aan terwijl er niets van ons liep, en precies in dat
     gaatje legt de app bij het laden van de pagina zijn cadeau neer: dat
     verzoek werd dan voor eigen werk aangezien, kreeg geen `_free_gift` mee én
     zette de bewaker niet aan. De patch op fetch leest de vlag synchroon, dus
     eromheen zetten en in finally weer uit is genoeg — en sluitend. */
  function eigenFetch(url, opties) {
    eigenAanroep = true;
    try {
      return fetch(url, opties);
    } finally {
      eigenAanroep = false;
    }
  }

  function sectieIds() {
    try {
      var helper = window.Alpine && window.Alpine.store ? window.Alpine.store('xCartHelper') : null;
      if (helper && typeof helper.getSectionsToRender === 'function') {
        return helper.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) { /* Alpine nog niet geladen */ }
    return null;
  }

  function cartHelper() {
    try {
      return window.Alpine && window.Alpine.store ? window.Alpine.store('xCartHelper') : null;
    } catch (e) { return null; }
  }

  function terugvalHerladen() {
    /* Alleen de mandpagina toont de regels al; de lade haalt bij openen tóch
       een verse /?sections=cart-drawer op en hoeft dus niet herladen. */
    if (window.location.pathname.indexOf('/cart') !== 0) return;
    /* Een laadbeurt die de bezoeker niet gevraagd heeft, hoort navraag te
       overleven: zonder dit spoor is achteraf niet te zien of de pagina door
       deze bewaker herladen werd of door een app. Dat kostte op 14 okt een
       half uur zoeken. */
    try { sessionStorage.setItem('hn-mandbewaker-herladen', String(Date.now())); } catch (e) { /* privémodus */ }
    window.location.reload();
  }

  function tekenSecties(helper, secties) {
    helper.reRenderSections(secties);
    /* Zoals theme.js het doet (r492): de teller uit de zojuist hertekende
       bubbel lezen in plaats van hem zelf uit te rekenen. */
    try {
      var bubbel = document.querySelector('#cart-icon-bubble span');
      if (bubbel) helper.currentItemCount = parseInt(bubbel.innerHTML, 10);
    } catch (e) { /* geen bubbel op deze pagina */ }
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  }

  /* HERLADEN IS DE LAATSTE UITWEG, NIET DE EERSTE.
     De eerste opzet leunde op de secties die /cart/change.js terugstuurt. Die
     komen er niet altijd, en dan ziet de bezoeker een laadbeurt voor iets wat
     hij niet gevraagd heeft. Daarom worden ze hier desnoods zelf opgehaald,
     met het huidige pad, zodat de mandpagina de mandsjabloonsecties
     terugkrijgt en niet die van de homepage. */
  function herrender(antwoord) {
    var helper = cartHelper();
    if (!helper || typeof helper.reRenderSections !== 'function') { terugvalHerladen(); return; }

    if (antwoord && antwoord.sections) { tekenSecties(helper, antwoord.sections); return; }

    var ids = sectieIds();
    if (!ids || !ids.length) { terugvalHerladen(); return; }

    /* HOOGUIT VIJF SECTIES PER AANROEP. Shopify's section rendering API
       antwoordt bij meer met een kale 400 zonder uitleg, en de mandpagina
       vraagt er zes (regels, voet, upsell en drie mandtellers). Dat was de
       echte reden dat de pagina herlaadde in plaats van hertekende: de
       terugvalweg deed precies wat hij moest doen, maar hij werd door een
       stille 400 aangeroepen. */
    var happen = [];
    for (var i = 0; i < ids.length; i += 5) happen.push(ids.slice(i, i + 5));

    Promise.all(happen.map(function (hap) {
      return eigenFetch(window.location.pathname + '?sections=' + hap.join(','))
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (delen) {
      var secties = {};
      var gelukt = false;
      for (var j = 0; j < delen.length; j += 1) {
        if (!delen[j]) continue;
        gelukt = true;
        for (var naam in delen[j]) {
          if (Object.prototype.hasOwnProperty.call(delen[j], naam)) secties[naam] = delen[j][naam];
        }
      }
      if (!gelukt) { terugvalHerladen(); return; }
      tekenSecties(helper, secties);
    });
  }

  function herstel(regel) {
    var lading = { id: regel.key, quantity: 1 };

    /* Eigenschappen gaan alléén mee als ze ook werkelijk veranderen, en nooit
       bij een regel van de app: met `properties` erbij geeft Shopify de regel
       een nieuwe sleutel. Zie de uitleg bovenaan. */
    if (vlagMagErbij(regel)) {
      var eigenschappen = {};
      var bestaand = regel.properties || {};
      for (var sleutel in bestaand) {
        if (Object.prototype.hasOwnProperty.call(bestaand, sleutel)) eigenschappen[sleutel] = bestaand[sleutel];
      }
      eigenschappen._free_gift = 'true';
      lading.properties = eigenschappen;
    }

    var ids = sectieIds();
    if (ids) {
      lading.sections = ids;
      lading.sections_url = window.location.pathname;
    }

    return eigenFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(lading),
    })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function ronde(n, veranderd) {
    if (n > MAX_RONDES) return Promise.resolve(veranderd);
    return eigenFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (mand) {
        if (!mand || !mand.items || !mand.items.length) return veranderd;
        var stuk = null;
        for (var i = 0; i < mand.items.length; i += 1) {
          if (moetHersteld(mand.items[i])) { stuk = mand.items[i]; break; }
        }
        if (!stuk) return veranderd;
        return herstel(stuk).then(function (antwoord) {
          /* Het antwoord van de laatst herstelde regel draagt de verse
             secties; die wordt na afloop gebruikt om te herrenderen. */
          return ronde(n + 1, antwoord || veranderd || true);
        });
      })
      .catch(function () {
        return veranderd;
      });
  }

  function bewaak() {
    if (bezig) return;
    bezig = true;
    ronde(1, null).then(function (veranderd) {
      bezig = false;
      if (veranderd) herrender(typeof veranderd === 'object' ? veranderd : null);
    });
  }

  /* Niet bij elke pagina een mandverzoek erbij als de mand toch leeg is. De
     teller in de header is server-side gevuld, dus die is hier al te lezen. */
  function bewaakAlsErIetsInDeMandZit() {
    var teller = document.querySelector('#cart-icon-bubble span');
    if (teller && String(teller.textContent).trim() === '0') return;
    bewaak();
  }

  /* Andere stukken thema die op een mandwijziging moeten reageren — op dit
     moment assets/hn-samples.js — haken hier aan in plaats van zelf nog een
     keer fetch te patchen. Twee patches zouden elkaars verzoeken voor vreemd
     aanzien en elkaar aan de gang houden; nu is er één wachtpost, één
     "dit ben ik zelf"-vlag en één wachttijd. */
  var luisteraars = [];

  function straksBewaken() {
    if (wachtend) clearTimeout(wachtend);
    wachtend = setTimeout(function () {
      wachtend = null;
      bewaak();
      for (var i = 0; i < luisteraars.length; i += 1) {
        try { luisteraars[i](); } catch (e) { /* een luisteraar mag de rest niet meeslepen */ }
      }
    }, 400);
  }

  function isMandSchrijven(url, methode) {
    if (!url) return false;
    if (String(methode || 'GET').toUpperCase() !== 'POST') return false;
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url));
  }

  function isToevoegen(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  /* DE EIGENSCHAP ERBIJ ZETTEN TERWIJL HET VERZOEK ONDERWEG IS.
     Alleen bij een regel die zichzelf al als cadeau aankondigt — we verzinnen
     geen cadeaus, we vullen er een aan. Lukt het ontleden niet (een
     formulierpost bijvoorbeeld, of een body die we niet kennen), dan gaat het
     verzoek ongemoeid door: liever geen eigenschap dan een kapot verzoek. */
  function vulLichaamAan(lichaam) {
    if (typeof lichaam !== 'string' || lichaam.charAt(0) !== '{') return null;
    var data;
    try { data = JSON.parse(lichaam); } catch (e) { return null; }
    var regels = data && data.items ? data.items : (data && data.id ? [data] : null);
    if (!regels || !regels.length) return null;
    var aangepast = false;
    for (var i = 0; i < regels.length; i += 1) {
      var p = regels[i].properties;
      if (!p || typeof p !== 'object') continue;
      if (!vanDeApp(p) && !p._gift && !p._free_gift) continue;
      if (heeftVlag(p)) continue;
      p._free_gift = 'true';
      aangepast = true;
    }
    if (!aangepast) return null;
    try { return JSON.stringify(data); } catch (e) { return null; }
  }

  /* fetch en XMLHttpRequest allebei, want een app hoeft zich niets van onze
     keuze aan te trekken. Eigen aanroepen worden overgeslagen, anders zou de
     bewaker zichzelf blijven aanzetten. */
  if (window.fetch) {
    var origineleFetch = window.fetch;
    window.fetch = function (bron, opties) {
      var url = typeof bron === 'string' ? bron : (bron && bron.url) || '';
      var methode = (opties && opties.method) || (bron && bron.method) || 'GET';
      var vanOns = eigenAanroep;

      if (KITE_VERZOEK_AANVULLEN && !vanOns && isToevoegen(url) && opties && opties.body) {
        var nieuw = vulLichaamAan(opties.body);
        if (nieuw) opties.body = nieuw;
      }

      var belofte = origineleFetch.apply(this, arguments);
      if (!vanOns && isMandSchrijven(url, methode)) belofte.then(straksBewaken, function () {});
      return belofte;
    };
  }

  var origineleOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (methode, url) {
    this.__hnMand = isMandSchrijven(url, methode);
    this.__hnToevoegen = KITE_VERZOEK_AANVULLEN && isToevoegen(url);
    this.__hnVanOns = eigenAanroep;
    return origineleOpen.apply(this, arguments);
  };
  var origineleSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (lichaam) {
    /* Eerst meeluisteren, dan pas eventueel een ander lichaam versturen —
       anders zou een aangevuld verzoek de bewaker níet aanzetten, juist het
       verzoek waar het om gaat. */
    if (this.__hnMand && !this.__hnVanOns) {
      this.addEventListener('loadend', straksBewaken);
    }
    if (this.__hnToevoegen && !this.__hnVanOns) {
      var nieuw = vulLichaamAan(lichaam);
      if (nieuw) return origineleSend.call(this, nieuw);
    }
    return origineleSend.apply(this, arguments);
  };

  document.addEventListener('eurus:cart:items-changed', straksBewaken);

  /* Zodat een meting kan zien hoe de bewaker ingesteld staat zonder de asset
     te moeten uitlezen — en zodat iemand die een vreemde mand onderzoekt in
     de console kan nakijken of dit bestand überhaupt draait. De drie functies
     zijn er voor hn-samples.js: eigenFetch zodat zijn verzoeken niet als
     vreemd tellen, herrender zodat de mand op dezelfde manier bijgetekend
     wordt, en opMandwijziging om mee te luisteren. */
  window.HNMandbewaker = {
    kiteVerzoekAanvullen: KITE_VERZOEK_AANVULLEN,
    eigenFetch: eigenFetch,
    herrender: herrender,
    opMandwijziging: function (cb) { if (typeof cb === 'function') luisteraars.push(cb); },
  };

  /* EERST WACHTEN OP ALPINE, EN DAAROM NIET METEEN BIJ DOMContentLoaded.
     Dit bestand laadt met defer in de head; Alpine komt pas met vendors.js
     onderaan de body. Draait de bewaker daarvóór, dan kan hij de sectie-id's
     niet meegeven, krijgt hij geen verse secties terug en valt hij op de
     mandpagina terug op herladen — dat werkt, maar het is een laadbeurt die
     de bezoeker ziet. Gemeten op 14 okt: precies dat gebeurde. Daarom hier
     maximaal drie seconden wachten tot xCartHelper er is en pas dan beginnen;
     is hij er dan nog steeds niet, dan gaat het alsnog door met de
     terugvalweg, want een cadeau te veel is erger dan een laadbeurt. */
  function startZodraHetKan(pogingen) {
    if (sectieIds() || pogingen >= 20) { bewaakAlsErIetsInDeMandZit(); return; }
    setTimeout(function () { startZodraHetKan(pogingen + 1); }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { startZodraHetKan(0); });
  } else {
    startZodraHetKan(0);
  }
})();
